(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
  /* Header — scroll state, mega menu hover behaviour, mobile menu
     drill-down. Mirrors the React useHeaderScroll + Header + MobileMenu
     trio without the framer-motion runtime. */
  (function () {
    if (window.__mamHeaderInit) return;
    window.__mamHeaderInit = true;

    function ready(fn) {
      if (document.readyState !== 'loading') fn();
      else document.addEventListener('DOMContentLoaded', fn);
    }

    /* — Header scroll state (top / scrolled / hidden) — */
    function wireScrollState(header) {
      var lastY = window.scrollY;
      var ticking = false;

      function anyHideZoneInView() {
        var vh = window.innerHeight || document.documentElement.clientHeight;
        var buffer = vh * 0.08;
        var zones = document.querySelectorAll('[data-hide-header]');
        for (var i = 0; i < zones.length; i++) {
          var r = zones[i].getBoundingClientRect();
          if (r.bottom > buffer && r.top < vh - buffer) return true;
        }
        return false;
      }

      function update() {
        ticking = false;
        var y = window.scrollY;
        var delta = y - lastY;
        var inHideZone = anyHideZoneInView();
        var current = header.getAttribute('data-state');
        var next = current;

        if (y < 40) {
          next = 'top';
        } else if (inHideZone && y > 80) {
          next = 'hidden';
        } else if (delta > 4 && y > 80) {
          next = 'hidden';
        } else if (delta < -2) {
          next = 'scrolled';
        } else if (y >= 40) {
          next = current === 'hidden' ? current : 'scrolled';
        }
        if (next !== current) header.setAttribute('data-state', next);
        lastY = y;
      }
      function onScroll() {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(update);
      }
      window.addEventListener('scroll', onScroll, { passive: true });
      update();
    }

    /* — Mega menu hover (desktop only) — */
    function wireMegaMenu(header) {
      var triggers = header.querySelectorAll('[data-mam-nav-trigger]');
      var megamenu = header.querySelector('[data-mam-megamenu]');
      var hoverLockoutUntil = 0;
      var closeTimer = null;

      function open(panel) {
        if (Date.now() < hoverLockoutUntil) return;
        if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
        header.setAttribute('data-active-panel', panel);
        for (var i = 0; i < triggers.length; i++) {
          var link = triggers[i].querySelector('.mam-header__nav-link');
          var on = triggers[i].getAttribute('data-mam-nav-trigger') === panel;
          if (link) link.setAttribute('aria-expanded', on ? 'true' : 'false');
        }
      }
      function scheduleClose(delay) {
        if (closeTimer) clearTimeout(closeTimer);
        closeTimer = setTimeout(function () {
          header.removeAttribute('data-active-panel');
          for (var i = 0; i < triggers.length; i++) {
            var link = triggers[i].querySelector('.mam-header__nav-link');
            if (link) link.setAttribute('aria-expanded', 'false');
          }
        }, delay);
      }

      for (var i = 0; i < triggers.length; i++) {
        (function (trigger) {
          var panel = trigger.getAttribute('data-mam-nav-trigger');
          trigger.addEventListener('mouseenter', function () { open(panel); });
          /* Keyboard support — Enter/Space on the link toggles the panel. */
          var link = trigger.querySelector('.mam-header__nav-link');
          if (link) {
            link.addEventListener('focus', function () {
              if (matchMedia('(min-width: 1200px)').matches) open(panel);
            });
          }
        })(triggers[i]);
      }
      header.addEventListener('mouseleave', function () { scheduleClose(150); });
      if (megamenu) {
        megamenu.addEventListener('mouseenter', function () {
          if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
        });
        megamenu.addEventListener('mouseleave', function () { scheduleClose(150); });
      }

      /* ESC closes the menu and applies a brief hover-lockout so the
         panel doesn't immediately reopen when the cursor is still over
         a nav trigger. */
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && header.hasAttribute('data-active-panel')) {
          header.removeAttribute('data-active-panel');
          hoverLockoutUntil = Date.now() + 250;
        }
      });
    }

    /* — Mobile menu open / close + drill-down. — */
    function wireMobileMenu(header) {
      var openBtn = header.querySelector('[data-mam-mobile-open]');
      var menu = document.querySelector('[data-mam-mobile-menu]');
      if (!openBtn || !menu) return;
      var closeBtn = menu.querySelector('[data-mam-mobile-close]');
      var drillBtns = menu.querySelectorAll('[data-mam-mobile-drill]');
      var backBtns = menu.querySelectorAll('[data-mam-mobile-back]');
      var closeLinks = menu.querySelectorAll('[data-mam-mobile-close-link]');

      function open() {
        menu.removeAttribute('hidden');
        /* Force reflow so the opacity transition runs. */
        void menu.offsetHeight;
        menu.classList.add('is-open');
        menu.setAttribute('aria-hidden', 'false');
        openBtn.setAttribute('aria-expanded', 'true');
        document.documentElement.classList.add('mam-mobile-menu-open');
        menu.setAttribute('data-mobile-view', 'root');
      }
      function close() {
        menu.classList.remove('is-open');
        menu.setAttribute('aria-hidden', 'true');
        openBtn.setAttribute('aria-expanded', 'false');
        document.documentElement.classList.remove('mam-mobile-menu-open');
        /* Wait out the opacity transition before hiding. */
        setTimeout(function () {
          if (!menu.classList.contains('is-open')) menu.setAttribute('hidden', '');
        }, 320);
      }

      openBtn.addEventListener('click', open);
      if (closeBtn) closeBtn.addEventListener('click', close);
      for (var i = 0; i < drillBtns.length; i++) {
        (function (btn) {
          var view = btn.getAttribute('data-mam-mobile-drill');
          btn.addEventListener('click', function () {
            menu.setAttribute('data-mobile-view', view);
          });
        })(drillBtns[i]);
      }
      for (var j = 0; j < backBtns.length; j++) {
        backBtns[j].addEventListener('click', function () {
          menu.setAttribute('data-mobile-view', 'root');
        });
      }
      for (var k = 0; k < closeLinks.length; k++) {
        closeLinks[k].addEventListener('click', close);
      }

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && menu.classList.contains('is-open')) close();
      });
    }

    function init(header) {
      if (header.__mamHeaderWired) return;
      header.__mamHeaderWired = true;
      wireScrollState(header);
      wireMegaMenu(header);
      wireMobileMenu(header);
    }

    ready(function () {
      var header = document.querySelector('[data-mam-header]');
      if (header) init(header);
    });

    document.addEventListener('shopify:section:load', function (e) {
      var header = (e.target || document).querySelector
        ? (e.target || document).querySelector('[data-mam-header]')
        : null;
      if (header) init(header);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mam-about-chapters"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__mamAboutChaptersInit) return;
    window.__mamAboutChaptersInit = true;

    function ready(fn) {
      if (document.readyState !== 'loading') fn();
      else document.addEventListener('DOMContentLoaded', fn);
    }

    ready(function () {
      if (!window.MAM) return;
      var roots = document.querySelectorAll('.mam-about-chapters');
      for (var i = 0; i < roots.length; i++) {
        MAM.observeReveals(roots[i]);
        MAM.observeWordReveals(roots[i]);
      }
    });

    document.addEventListener('shopify:section:load', function (e) {
      if (e && e.target && window.MAM) {
        MAM.observeReveals(e.target);
        MAM.observeWordReveals(e.target);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mam-about-collective"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__mamAboutCollectiveInit) return;
    window.__mamAboutCollectiveInit = true;

    function ready(fn) {
      if (document.readyState !== 'loading') fn();
      else document.addEventListener('DOMContentLoaded', fn);
    }

    ready(function () {
      if (!window.MAM) return;
      var roots = document.querySelectorAll('.mam-about-coll');
      for (var i = 0; i < roots.length; i++) {
        MAM.observeReveals(roots[i]);
        MAM.observeWordReveals(roots[i]);
      }
    });

    document.addEventListener('shopify:section:load', function (e) {
      if (e && e.target && window.MAM) {
        MAM.observeReveals(e.target);
        MAM.observeWordReveals(e.target);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mam-about-cornwall"] && !Shopify.designMode) return;
  try {
    
  /* Parallax — single passive scroll listener that tracks every
     `[data-mam-cornwall]` section on the page. Using rAF so the
     transform writes never block the main thread, and a guard flag
     so we never bind twice on the same section instance. Mirrors
     `useScroll` + `useTransform` in the React `CornwallSpread`:
       - imageY drifts -6% → 8% across the section's viewport pass
       - imageScale eases 1.06 → 1.02 → 1.06 (slight breathe). */
  (function () {
    if (window.__mamCornwallInit) return;
    window.__mamCornwallInit = true;

    var REDUCED_MOTION_QUERY = '(prefers-reduced-motion: reduce)';
    var prefersReduced = window.matchMedia(REDUCED_MOTION_QUERY).matches;

    var sections = [];
    var ticking = false;

    function ready(fn) {
      if (document.readyState !== 'loading') fn();
      else document.addEventListener('DOMContentLoaded', fn);
    }

    function clamp(v, lo, hi) { return v < lo ? lo : v > hi ? hi : v; }

    function update() {
      ticking = false;
      var vh = window.innerHeight || document.documentElement.clientHeight;
      for (var i = 0; i < sections.length; i++) {
        var s = sections[i];
        if (!s.image) continue;
        var rect = s.section.getBoundingClientRect();
        /* progress: 0 when the section's top is at the bottom of the
           viewport, 1 when its bottom hits the top — matches React's
           `["start end", "end start"]` scroll offsets. */
        var range = rect.height + vh;
        var p = clamp(1 - (rect.bottom / range), 0, 1);
        var y = (-6 + p * 14); // -6% → 8%
        var midDist = Math.abs(p - 0.5) * 2; // 0 at middle, 1 at edges
        var sc = 1.02 + midDist * 0.04; // 1.02 at mid, 1.06 at edges
        s.image.style.transform = 'translate3d(0, ' + y.toFixed(2) + '%, 0) scale(' + sc.toFixed(3) + ')';
      }
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(update);
    }

    function collect() {
      sections = [];
      var roots = document.querySelectorAll('[data-mam-cornwall]');
      for (var i = 0; i < roots.length; i++) {
        sections.push({
          section: roots[i],
          image: roots[i].querySelector('[data-mam-cornwall-image]')
        });
      }
    }

    ready(function () {
      collect();
      if (window.MAM) {
        var roots = document.querySelectorAll('.mam-about-cornwall');
        for (var i = 0; i < roots.length; i++) {
          MAM.observeReveals(roots[i]);
          MAM.observeWordReveals(roots[i]);
        }
      }
      if (prefersReduced || sections.length === 0) return;
      update();
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll, { passive: true });
    });

    /* Theme-editor section reload — re-collect roots so a freshly
       inserted Cornwall instance picks up the parallax and reveals. */
    document.addEventListener('shopify:section:load', function (e) {
      collect();
      if (e && e.target && window.MAM) {
        MAM.observeReveals(e.target);
        MAM.observeWordReveals(e.target);
      }
      update();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mam-about-disciplines"] && !Shopify.designMode) return;
  try {
    
  /* Shopify's `{% javascript %}` blocks are bundled into a single
     theme-level file and executed once per page. `document.currentScript`
     therefore points at the bundle (in <head>), NOT inside the section,
     so the per-section root has to be discovered with a query selector
     against the page. Mirrors the pattern used in `mam-framework.liquid`. */
  (function () {
    if (window.__mamAboutDisciplinesInit) return;
    window.__mamAboutDisciplinesInit = true;

    function ready(fn) {
      if (document.readyState !== 'loading') fn();
      else document.addEventListener('DOMContentLoaded', fn);
    }

    function initCard(card) {
      if (card.__mamDiscInited) return;
      card.__mamDiscInited = true;

      /* Each card may have one or two video elements — one universal
         video, or a mobile + desktop pair where breakpoint CSS hides
         the inactive one via `display: none`. Walk all of them so
         click / play / pause wiring works regardless of which is
         visible at any given moment. */
      var videos = card.querySelectorAll('[data-mam-disc-video]');
      var playBtn = card.querySelector('[data-mam-disc-play]');
      if (!videos.length) return;

      function getActiveVideo() {
        for (var i = 0; i < videos.length; i++) {
          if (videos[i].offsetParent !== null) return videos[i];
        }
        return videos[0];
      }

      function toggle() {
        var video = getActiveVideo();
        if (!video) return;
        if (video.paused) {
          var p = video.play();
          if (p && typeof p.catch === 'function') p.catch(function () {});
        } else {
          video.pause();
        }
      }

      if (playBtn) {
        playBtn.setAttribute('data-play-label', playBtn.getAttribute('aria-label') || 'Play video');
        playBtn.setAttribute('data-pause-label', 'Pause video');
        playBtn.addEventListener('click', toggle);
      }

      for (var i = 0; i < videos.length; i++) {
        var v = videos[i];
        v.addEventListener('click', toggle);
        v.addEventListener('play', function () {
          card.classList.add('is-playing');
          if (playBtn) playBtn.setAttribute('aria-label', playBtn.getAttribute('data-pause-label') || 'Pause video');
        });
        v.addEventListener('pause', function () {
          card.classList.remove('is-playing');
          if (playBtn) playBtn.setAttribute('aria-label', playBtn.getAttribute('data-play-label') || 'Play video');
        });
        v.addEventListener('ended', function () {
          card.classList.remove('is-playing');
        });
      }
    }

    function initAll() {
      var cards = document.querySelectorAll('[data-mam-disc-card]');
      for (var i = 0; i < cards.length; i++) initCard(cards[i]);

      /* Reveals — same scoping fix: query the section root globally. */
      if (window.MAM) {
        var roots = document.querySelectorAll('.mam-about-disciplines');
        for (var j = 0; j < roots.length; j++) {
          MAM.observeReveals(roots[j]);
          MAM.observeWordReveals(roots[j]);
        }
      }
    }

    ready(initAll);

    /* Re-init for theme editor section reloads. */
    document.addEventListener('shopify:section:load', function (e) {
      if (!e.target) return;
      var cards = e.target.querySelectorAll('[data-mam-disc-card]');
      for (var i = 0; i < cards.length; i++) initCard(cards[i]);
      if (window.MAM) {
        MAM.observeReveals(e.target);
        MAM.observeWordReveals(e.target);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mam-about-hero"] && !Shopify.designMode) return;
  try {
    
  if (window.MAM) {
    var scope = document.currentScript ? document.currentScript.parentElement : document;
    MAM.observeReveals(scope);
    MAM.observeWordReveals(scope);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mam-about-intro"] && !Shopify.designMode) return;
  try {
    
  if (window.MAM) {
    var scope = document.currentScript ? document.currentScript.parentElement : document;
    MAM.observeReveals(scope);
    MAM.observeWordReveals(scope);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mam-apothecary-scrap"] && !Shopify.designMode) return;
  try {
    
  /* Scrap-style apothecary — per-video click toggle + reveal observer.
     Idempotent so it survives shopify:section:load. */
  (function () {
    if (window.__mamApothScrapInit) return;
    window.__mamApothScrapInit = true;

    function ready(fn) {
      if (document.readyState !== 'loading') fn();
      else document.addEventListener('DOMContentLoaded', fn);
    }

    var revealObserver = null;
    function getRevealObserver() {
      if (revealObserver) return revealObserver;
      if (!('IntersectionObserver' in window)) return null;
      revealObserver = new IntersectionObserver(function (entries) {
        for (var i = 0; i < entries.length; i++) {
          if (entries[i].isIntersecting) {
            var el = entries[i].target;
            var delay = parseInt(el.getAttribute('data-mam-reveal-delay') || '0', 10);
            if (delay > 0) {
              setTimeout(function () { el.classList.add('is-shown'); }, delay);
            } else {
              el.classList.add('is-shown');
            }
            revealObserver.unobserve(el);
          }
        }
      }, { rootMargin: '0px 0px -10% 0px', threshold: 0.05 });
      return revealObserver;
    }
    function observeReveals(scope) {
      var els = (scope || document).querySelectorAll('[data-mam-reveal]:not(.is-shown)');
      var obs = getRevealObserver();
      if (!obs) {
        for (var i = 0; i < els.length; i++) els[i].classList.add('is-shown');
        return;
      }
      for (var j = 0; j < els.length; j++) obs.observe(els[j]);
    }

    function wireFrame(btn) {
      if (btn.__mamApothScrapWired) return;
      btn.__mamApothScrapWired = true;
      var vid = btn.querySelector('[data-mam-apoth-scrap-video]');
      if (!vid) return;
      btn.addEventListener('click', function () {
        if (vid.paused) {
          var p = vid.play();
          if (p && typeof p.catch === 'function') p.catch(function () {});
        } else {
          vid.pause();
        }
      });
      vid.addEventListener('play', function () { btn.classList.add('is-playing'); });
      vid.addEventListener('pause', function () { btn.classList.remove('is-playing'); });
      vid.addEventListener('ended', function () { btn.classList.remove('is-playing'); });
    }

    function initAll(scope) {
      var btns = (scope || document).querySelectorAll('[data-mam-apoth-scrap-toggle]');
      for (var i = 0; i < btns.length; i++) wireFrame(btns[i]);
      observeReveals(scope || document);
    }

    ready(function () { initAll(document); });
    document.addEventListener('shopify:section:load', function (e) {
      if (e.target && e.target.classList && e.target.classList.contains('section-mam-apoth-scrap')) {
        initAll(e.target);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mam-apothecary"] && !Shopify.designMode) return;
  try {
    
  /* Apothecary — desktop hover/click + mobile tap behaviour. The
     composite media is the default; tabs swap to a founder's media
     stack on hover (desktop) or tap (mobile). On desktop, click
     additionally collapses the editorial spread to a single founder
     view. Idempotent — safe to re-run on shopify:section:load. */
  (function () {
    if (window.__mamApothecaryInit) return;
    window.__mamApothecaryInit = true;

    function ready(fn) {
      if (document.readyState !== 'loading') fn();
      else document.addEventListener('DOMContentLoaded', fn);
    }

    /* Reveal observer — same playbook as mam-apothecary v1. */
    var revealObserver = null;
    function getRevealObserver() {
      if (revealObserver) return revealObserver;
      if (!('IntersectionObserver' in window)) return null;
      revealObserver = new IntersectionObserver(function (entries) {
        for (var i = 0; i < entries.length; i++) {
          if (entries[i].isIntersecting) {
            entries[i].target.classList.add('is-shown');
            revealObserver.unobserve(entries[i].target);
          }
        }
      }, { rootMargin: '0px 0px -10% 0px', threshold: 0.05 });
      return revealObserver;
    }
    function observeReveals(scope) {
      var els = (scope || document).querySelectorAll('[data-mam-apothecary-reveal]:not(.is-shown)');
      var obs = getRevealObserver();
      if (!obs) {
        for (var i = 0; i < els.length; i++) els[i].classList.add('is-shown');
        return;
      }
      for (var j = 0; j < els.length; j++) obs.observe(els[j]);
    }

    function wire(root) {
      if (root.__mamApothecaryWired) return;
      root.__mamApothecaryWired = true;

      /* — Desktop frame ——————————————————————————————————— */
      var frame = root.querySelector('[data-mam-apothecary-frame]');
      var spread = root.querySelector('[data-mam-apothecary-spread]');
      var dualBlock = root.querySelector('[data-mam-spread="dual"]');
      var soloBlocks = root.querySelectorAll('[data-mam-spread="solo"]');
      var tabs = root.querySelectorAll('[data-mam-apothecary-tab]');
      var medias = root.querySelectorAll('[data-mam-media]');
      var playBtn = root.querySelector('[data-mam-apothecary-play]');

      var hoverSlug = null;
      var selectedSlug = null;

      /* Show whichever media stack matches `slug` (or composite if null). */
      function showMedia(slug) {
        var target = slug || 'composite';
        for (var i = 0; i < medias.length; i++) {
          var m = medias[i];
          var on = m.getAttribute('data-mam-media') === target;
          m.classList.toggle('is-active', on);
          /* Keep the videos paused unless they're the active stack so
             we don't burn frames in the background. */
          var vid = m.querySelector('[data-mam-apothecary-video]');
          if (vid && !on && !vid.paused) vid.pause();
        }
        /* Reset the play overlay whenever we swap media so the user
           always starts from the play state on a new founder. */
        if (frame) frame.classList.remove('is-playing');
      }

      function paintTabs() {
        var visibleSlug = hoverSlug || selectedSlug;
        for (var i = 0; i < tabs.length; i++) {
          var slug = tabs[i].getAttribute('data-mam-apothecary-tab');
          var on = slug === visibleSlug;
          tabs[i].classList.toggle('is-active', on);
          tabs[i].setAttribute('aria-selected', on ? 'true' : 'false');
          tabs[i].setAttribute('aria-pressed', selectedSlug === slug ? 'true' : 'false');
        }
      }

      function paintSpread() {
        if (!spread) return;
        var solo = selectedSlug
          ? root.querySelector('[data-mam-spread="solo"][data-mam-spread-slug="' + selectedSlug + '"]')
          : null;
        if (selectedSlug && solo) {
          spread.classList.add('is-solo');
          if (dualBlock) dualBlock.style.display = 'none';
          for (var i = 0; i < soloBlocks.length; i++) soloBlocks[i].setAttribute('hidden', '');
          solo.removeAttribute('hidden');
        } else {
          spread.classList.remove('is-solo');
          if (dualBlock) dualBlock.style.display = '';
          for (var j = 0; j < soloBlocks.length; j++) soloBlocks[j].setAttribute('hidden', '');
        }
      }

      function refresh() {
        showMedia(hoverSlug || selectedSlug);
        paintTabs();
        paintSpread();
      }

      for (var t = 0; t < tabs.length; t++) {
        (function (tab) {
          var slug = tab.getAttribute('data-mam-apothecary-tab');
          tab.addEventListener('mouseenter', function () {
            hoverSlug = slug;
            refresh();
          });
          tab.addEventListener('focus', function () {
            hoverSlug = slug;
            refresh();
          });
          tab.addEventListener('click', function () {
            selectedSlug = (selectedSlug === slug) ? null : slug;
            refresh();
          });
        })(tabs[t]);
      }
      /* Tab row mouseleave clears hover (selection persists). */
      var tabRow = root.querySelector('[data-mam-apothecary-tabs]');
      if (tabRow) {
        tabRow.addEventListener('mouseleave', function () {
          hoverSlug = null;
          refresh();
        });
      }

      /* Composite/per-founder play toggle for the single visible video. */
      function activeVideo() {
        var active = root.querySelector('.mam-apothecary__media.is-active [data-mam-apothecary-video]');
        return active || null;
      }
      function togglePlay() {
        var vid = activeVideo();
        if (!vid || !frame) return;
        if (vid.paused) {
          var p = vid.play();
          if (p && typeof p.catch === 'function') p.catch(function () {});
        } else {
          vid.pause();
        }
      }
      if (playBtn) playBtn.addEventListener('click', togglePlay);
      /* Click on the active video (full panel) toggles too. */
      root.addEventListener('click', function (e) {
        if (e.target && e.target.matches && e.target.matches('[data-mam-apothecary-video]')) {
          togglePlay();
        }
      });
      /* Sync .is-playing on the frame from the active video's events. */
      for (var v = 0; v < medias.length; v++) {
        var vid = medias[v].querySelector('[data-mam-apothecary-video]');
        if (!vid) continue;
        vid.addEventListener('play', function () { if (frame) frame.classList.add('is-playing'); });
        vid.addEventListener('pause', function () { if (frame) frame.classList.remove('is-playing'); });
        vid.addEventListener('ended', function () { if (frame) frame.classList.remove('is-playing'); });
      }

      /* — Mobile card ————————————————————————————————————— */
      var mFrame = root.querySelector('.mam-apothecary__mobile-frame');
      var mTabs = root.querySelectorAll('[data-mam-mobile-tab]');
      var mMedias = root.querySelectorAll('[data-mam-mobile-media]');
      var mCopies = root.querySelectorAll('[data-mam-mobile-copy]');
      var mPlay = root.querySelector('[data-mam-mobile-play]');
      var mActiveSlug = null;

      function setMobileSlug(slug) {
        var target = slug || 'composite';
        for (var i = 0; i < mMedias.length; i++) {
          var m = mMedias[i];
          var on = m.getAttribute('data-mam-mobile-media') === target;
          m.classList.toggle('is-active', on);
          var vid = m.querySelector('[data-mam-mobile-video]');
          if (vid && !on && !vid.paused) vid.pause();
        }
        for (var j = 0; j < mCopies.length; j++) {
          var c = mCopies[j];
          c.classList.toggle('is-active', c.getAttribute('data-mam-mobile-copy') === target);
        }
        for (var k = 0; k < mTabs.length; k++) {
          var t = mTabs[k];
          var slugK = t.getAttribute('data-mam-mobile-tab');
          var onK = slug !== null && slugK === slug;
          t.classList.toggle('is-active', onK);
          t.setAttribute('aria-selected', onK ? 'true' : 'false');
          t.setAttribute('aria-pressed', onK ? 'true' : 'false');
        }
        if (mFrame) mFrame.classList.remove('is-playing');
      }
      for (var mt = 0; mt < mTabs.length; mt++) {
        (function (tab) {
          var slug = tab.getAttribute('data-mam-mobile-tab');
          tab.addEventListener('click', function () {
            mActiveSlug = (mActiveSlug === slug) ? null : slug;
            setMobileSlug(mActiveSlug);
          });
        })(mTabs[mt]);
      }
      function mActiveVideo() {
        var active = root.querySelector('.mam-apothecary__mobile-media.is-active [data-mam-mobile-video]');
        return active || null;
      }
      if (mPlay) {
        mPlay.addEventListener('click', function () {
          var vid = mActiveVideo();
          if (!vid) return;
          if (vid.paused) {
            var p = vid.play();
            if (p && typeof p.catch === 'function') p.catch(function () {});
          } else {
            vid.pause();
          }
        });
      }
      for (var mv = 0; mv < mMedias.length; mv++) {
        var mvid = mMedias[mv].querySelector('[data-mam-mobile-video]');
        if (!mvid) continue;
        mvid.addEventListener('play', function () { if (mFrame) mFrame.classList.add('is-playing'); });
        mvid.addEventListener('pause', function () { if (mFrame) mFrame.classList.remove('is-playing'); });
        mvid.addEventListener('ended', function () { if (mFrame) mFrame.classList.remove('is-playing'); });
      }

      refresh();
      observeReveals(root);
    }

    function initAll(scope) {
      var roots = (scope || document).querySelectorAll('[data-mam-apothecary]');
      for (var i = 0; i < roots.length; i++) wire(roots[i]);
    }

    ready(function () { initAll(document); });
    document.addEventListener('shopify:section:load', function (e) {
      if (e.target && e.target.classList && e.target.classList.contains('section-mam-apothecary')) {
        initAll(e.target);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mam-article-view"]) return;
  try {
    
  (function () {
    if (window.__mamArticleInit) return;
    window.__mamArticleInit = true;

    function ready(fn) {
      if (document.readyState !== 'loading') fn();
      else document.addEventListener('DOMContentLoaded', fn);
    }

    function slugify(text) {
      return String(text)
        .toLowerCase()
        .replace(/[^\p{L}\p{N}]+/gu, '-')
        .replace(/^-+|-+$/g, '');
    }

    function init(root) {
      if (!root || root.__mamArticleWired) return;
      root.__mamArticleWired = true;

      var prose = root.querySelector('[data-mam-article-prose]');
      var tocList = root.querySelector('[data-mam-article-toc]');
      var tocWrap = root.querySelector('[data-mam-article-toc-wrap]');
      var body = root.querySelector('[data-mam-article-body]');
      var progress = root.querySelector('[data-mam-article-progress]');
      var progressBar = root.querySelector('[data-mam-article-progress-bar]');
      var copyBtn = root.querySelector('[data-mam-article-copy]');
      var copiedLabel = root.querySelector('[data-mam-article-copied]');

      if (prose && tocList) {
        var headings = prose.querySelectorAll('h2');
        if (headings.length === 0) {
          /* Hide the sidebar AND flag the grid container so CSS can
             collapse to a single centred column — without that
             flag, grid auto-place drops the article into the empty
             TOC slot. The class goes on `.mam-article__body-inner`
             (the grid itself), not the outer wrapper. */
          if (tocWrap) tocWrap.style.display = 'none';
          var bodyInner = root.querySelector('.mam-article__body-inner');
          if (bodyInner) bodyInner.classList.add('is-no-toc');
        } else {
          for (var h = 0; h < headings.length; h++) {
            var heading = headings[h];
            var id = heading.id;
            if (!id) {
              id = slugify(heading.textContent || ('section-' + (h + 1)));
              if (!id) id = 'section-' + (h + 1);
              heading.id = id;
            }
            var li = document.createElement('li');
            li.className = 'mam-article__toc-item';
            li.setAttribute('data-toc-id', id);
            var a = document.createElement('a');
            a.className = 'mam-article__toc-link';
            a.href = '#' + id;
            a.textContent = heading.textContent || '';
            a.addEventListener('click', (function (targetId) {
              return function (e) {
                e.preventDefault();
                var t = document.getElementById(targetId);
                if (t) t.scrollIntoView({ behavior: 'smooth', block: 'start' });
              };
            })(id));
            li.appendChild(a);
            tocList.appendChild(li);
          }

          var items = tocList.querySelectorAll('[data-toc-id]');
          function setActive(id) {
            for (var i = 0; i < items.length; i++) {
              if (items[i].getAttribute('data-toc-id') === id) {
                items[i].classList.add('is-active');
              } else {
                items[i].classList.remove('is-active');
              }
            }
          }
          if (headings[0] && headings[0].id) setActive(headings[0].id);

          var io = new IntersectionObserver(function (entries) {
            var visible = entries.filter(function (e) { return e.isIntersecting; });
            visible.sort(function (a, b) {
              return Math.abs(a.boundingClientRect.top) - Math.abs(b.boundingClientRect.top);
            });
            if (visible[0]) setActive(visible[0].target.id);
          }, { rootMargin: '-20% 0px -65% 0px', threshold: 0 });
          for (var k = 0; k < headings.length; k++) io.observe(headings[k]);
        }
      }

      if (body && progressBar) {
        var rafPending = false;
        function update() {
          rafPending = false;
          var rect = body.getBoundingClientRect();
          var vh = window.innerHeight || document.documentElement.clientHeight;
          var start = rect.top - vh * 0.8;
          var end = rect.bottom - vh * 0.6;
          var range = end - start;
          var local = 0 - start;
          var raw = range > 0 ? local / range : 0;
          var clamped = raw < 0 ? 0 : raw > 1 ? 1 : raw;
          progressBar.style.transform = 'scaleX(' + clamped + ')';
        }
        function schedule() {
          if (rafPending) return;
          rafPending = true;
          requestAnimationFrame(update);
        }
        window.addEventListener('scroll', schedule, { passive: true });
        window.addEventListener('resize', schedule);
        update();

        /* The theme header is `[data-mam-header]` and flips its
           `data-state` between `top`, `scrolled`, and `hidden`. When
           it's `hidden` the header slides offscreen, so we snap the
           progress strip up to top:0 to avoid an empty gap where
           the header used to sit. MutationObserver watches the
           attribute and re-syncs the strip live. */
        var headerEl = document.querySelector('[data-mam-header]');
        function syncHeaderState() {
          if (!progress) return;
          var hidden = false;
          if (headerEl) {
            var state = headerEl.getAttribute('data-state');
            hidden = state === 'hidden';
          }
          if (hidden) progress.classList.add('is-header-hidden');
          else progress.classList.remove('is-header-hidden');
        }
        if (headerEl && 'MutationObserver' in window) {
          var mo = new MutationObserver(syncHeaderState);
          mo.observe(headerEl, { attributes: true, attributeFilter: ['data-state'] });
        }
        syncHeaderState();
      }

      if (copyBtn) {
        function showCopied() {
          copyBtn.classList.add('is-active');
          if (copiedLabel) copiedLabel.hidden = false;
          clearTimeout(copyBtn.__mamFlashTo);
          copyBtn.__mamFlashTo = setTimeout(function () {
            copyBtn.classList.remove('is-active');
            if (copiedLabel) copiedLabel.hidden = true;
          }, 1800);
        }
        copyBtn.addEventListener('click', function () {
          var url = window.location.href;
          if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(url).then(showCopied).catch(function () {});
          } else {
            try {
              var input = document.createElement('input');
              input.value = url;
              document.body.appendChild(input);
              input.select();
              document.execCommand('copy');
              document.body.removeChild(input);
              showCopied();
            } catch (e) {}
          }
        });
      }

      if (window.MAM) {
        MAM.observeReveals(root);
        MAM.observeWordReveals(root);
      }
    }

    function initAll(scope) {
      var roots = (scope || document).querySelectorAll('[data-mam-article-view]');
      for (var i = 0; i < roots.length; i++) init(roots[i]);
    }

    ready(function () { initAll(document); });
    document.addEventListener('shopify:section:load', function (e) {
      if (e.target) initAll(e.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mam-bioactives-carousel"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__mamBioCarInit) return;
    window.__mamBioCarInit = true;

    function ready(fn) {
      if (document.readyState !== 'loading') fn();
      else document.addEventListener('DOMContentLoaded', fn);
    }

    function initSection(root) {
      if (!root || root.__mamBioCarBound) return;
      root.__mamBioCarBound = true;

      var track = root.querySelector('[data-mam-bio-car-track]');
      var prev = root.querySelector('[data-mam-bio-car-prev]');
      var next = root.querySelector('[data-mam-bio-car-next]');
      var dotsHost = root.querySelector('[data-mam-bio-car-dots]');
      var modal = root.parentElement.querySelector('[data-mam-bio-car-modal]')
        || document.querySelector('[data-mam-bio-car-modal]');

      /* Duplicate the cards so horizontal scroll wraps seamlessly —
         mirrors the React `doubled = [...cards, ...cards]` pattern.
         Only duplicate when there are enough cards to actually need
         the loop wrap (>= 4); below that the track stays static.
         Capture the original count before cloning so the dot
         indicators map 1:1 to the real cards, not the duplicates. */
      var originalCount = 0;
      if (track) {
        var originals = track.querySelectorAll('[data-mam-bio-car-slot]');
        originalCount = originals.length;
        if (originalCount >= 4) {
          for (var i = 0; i < originals.length; i++) {
            var clone = originals[i].cloneNode(true);
            clone.setAttribute('data-mam-bio-car-clone', 'true');
            track.appendChild(clone);
          }
        }
      }

      /* Build pagination dots — one per original slot. Clicking a
         dot scrolls the matching slot into view. The active dot is
         driven by the scroll handler below. */
      var dots = [];
      if (dotsHost && originalCount > 1) {
        for (var d = 0; d < originalCount; d++) {
          (function (idx) {
            var dot = document.createElement('button');
            dot.type = 'button';
            dot.className = 'mam-bio-car__dot';
            dot.setAttribute('role', 'tab');
            dot.setAttribute('aria-label', 'Go to ingredient ' + (idx + 1));
            dot.addEventListener('click', function () {
              var slots = track.querySelectorAll('[data-mam-bio-car-slot]');
              if (!slots[idx]) return;
              var target = slots[idx].offsetLeft - (track.clientWidth - slots[idx].offsetWidth) / 2;
              track.scrollTo({ left: Math.max(0, target), behavior: 'smooth' });
            });
            dotsHost.appendChild(dot);
            dots.push(dot);
          })(d);
        }
      }
      function setActiveDot(idx) {
        for (var k = 0; k < dots.length; k++) {
          if (k === idx) dots[k].classList.add('is-active');
          else dots[k].classList.remove('is-active');
        }
      }

      if (track) {
        /* Scroll handler: wrap the seamless loop AND derive which
           original-card index is currently centred so the dot row
           can highlight the right one. We modulo into the original
           range so clones still advance the same dot as their
           originals. */
        function onScroll() {
          var half = track.scrollWidth / 2;
          if (originalCount >= 4) {
            if (track.scrollLeft >= half) track.scrollLeft -= half;
            else if (track.scrollLeft < 0) track.scrollLeft += half;
          }
          if (dots.length) {
            var slots = track.querySelectorAll('[data-mam-bio-car-slot]');
            if (!slots.length) return;
            /* Use the slot whose left edge sits closest to
               `scrollLeft + leadingPadding` rather than "closest to
               viewport centre". When the track is scrolled all the
               way left (scrollLeft ≈ 0), the leading 4vw padding
               offsets the cards so the visual centre lands on slot
               1 or 2 — the centre-based metric would highlight that
               middle dot instead of dot 0. Anchoring to the leading
               edge means scrollLeft=0 always picks slot[0], and
               every subsequent slot-width step advances by one dot. */
            var leadingOffset = slots[0].offsetLeft;
            var refX = track.scrollLeft + leadingOffset;
            var bestIdx = 0;
            var bestDist = Infinity;
            for (var s = 0; s < slots.length; s++) {
              var dist = Math.abs(slots[s].offsetLeft - refX);
              if (dist < bestDist) { bestDist = dist; bestIdx = s; }
            }
            setActiveDot(bestIdx % originalCount);
          }
        }
        track.addEventListener('scroll', onScroll, { passive: true });
        /* Initial dot state. */
        if (dots.length) setActiveDot(0);

        function nudge(dir) {
          var card = track.querySelector('[data-mam-bio-car-slot]');
          var step = card ? card.offsetWidth + 28 : 300;
          track.scrollBy({ left: dir * step, behavior: 'smooth' });
        }
        if (prev) prev.addEventListener('click', function () { nudge(-1); });
        if (next) next.addEventListener('click', function () { nudge(1); });

        /* Pointer-drag swipe on desktop with inertia. Touch devices
           already get horizontal swipe + native momentum via the
           track's `overflow-x: auto`, so we restrict this handler to
           `pointerType === 'mouse'` to avoid double-handling.

           Key detail: we DON'T call `setPointerCapture` on pointerdown.
           Capturing redirects the pointerup event to the track instead
           of the card, which then dispatches `click` on the track
           rather than the card — that swallows the modal-opening
           click for ordinary (non-dragging) clicks. Instead we capture
           lazily, only once the pointer has moved past a 4px threshold
           (`drag.moved`). Stationary clicks never trigger capture, so
           the native `click` event fires on the card as normal.

           Inertia: every pointermove samples an instantaneous
           velocity (px / ms) and blends it into `drag.velocity` so
           the value at release reflects the user's recent motion,
           not their first-frame jitter. On pointerup with a real
           drag we start a requestAnimationFrame loop that applies
           the velocity and decays it exponentially each frame,
           mimicking native touch-momentum scrolling. A fresh
           pointerdown cancels any in-flight inertia so the user
           can "grab to stop" a sliding track. */
        var drag = {
          down: false, captured: false, moved: false, pointerId: -1,
          startX: 0, startScroll: 0,
          lastX: 0, lastTime: 0, velocity: 0
        };
        var inertiaRaf = 0;
        function stopInertia() {
          if (inertiaRaf) {
            cancelAnimationFrame(inertiaRaf);
            inertiaRaf = 0;
          }
        }
        function startInertia(initialVelocity) {
          /* Velocity is in px/ms of pointer motion; the track's
             scrollLeft moves in the OPPOSITE direction (drag right
             ⇒ scrollLeft decreases). Decay factor 0.95 per 16ms
             frame ≈ a half-life of ~220ms — slow enough to feel
             like real momentum, fast enough that the track settles
             within a beat. */
          var velocity = initialVelocity;
          if (Math.abs(velocity) < 0.08) return;
          var lastTs = (typeof performance !== 'undefined' && performance.now) ? performance.now() : Date.now();
          function step() {
            var now = (typeof performance !== 'undefined' && performance.now) ? performance.now() : Date.now();
            var dt = Math.min(now - lastTs, 48);
            lastTs = now;
            var before = track.scrollLeft;
            track.scrollLeft = before - velocity * dt;
            /* If we hit a scroll boundary (no infinite wrap and the
               browser clamped scrollLeft), kill the inertia. */
            if (track.scrollLeft === before) { inertiaRaf = 0; return; }
            velocity *= Math.pow(0.95, dt / 16);
            if (Math.abs(velocity) < 0.02) { inertiaRaf = 0; return; }
            inertiaRaf = requestAnimationFrame(step);
          }
          inertiaRaf = requestAnimationFrame(step);
        }

        function nowMs() {
          return (typeof performance !== 'undefined' && performance.now) ? performance.now() : Date.now();
        }

        track.addEventListener('pointerdown', function (e) {
          if (e.pointerType !== 'mouse') return;
          stopInertia();
          drag.down = true;
          drag.captured = false;
          drag.moved = false;
          drag.startX = e.clientX;
          drag.startScroll = track.scrollLeft;
          drag.pointerId = e.pointerId;
          drag.lastX = e.clientX;
          drag.lastTime = nowMs();
          drag.velocity = 0;
        });
        track.addEventListener('pointermove', function (e) {
          if (!drag.down) return;
          var delta = e.clientX - drag.startX;
          if (!drag.moved && Math.abs(delta) > 4) {
            drag.moved = true;
            track.style.cursor = 'grabbing';
            try { track.setPointerCapture(drag.pointerId); drag.captured = true; } catch (err) {}
          }
          if (drag.moved) {
            track.scrollLeft = drag.startScroll - delta;
            /* Blend instantaneous velocity into the running estimate.
               Heavier weight on the new sample (0.7) so the value
               at release tracks the user's most recent motion, not
               an averaged old reading. */
            var now = nowMs();
            var dt = now - drag.lastTime;
            if (dt > 0) {
              var instantaneous = (e.clientX - drag.lastX) / dt;
              drag.velocity = drag.velocity * 0.3 + instantaneous * 0.7;
            }
            drag.lastX = e.clientX;
            drag.lastTime = now;
          }
        });
        function endDrag(e) {
          if (!drag.down) return;
          var wasDragging = drag.moved;
          drag.down = false;
          if (drag.captured) {
            try { track.releasePointerCapture(drag.pointerId); } catch (err) {}
            drag.captured = false;
          }
          track.style.cursor = '';
          if (wasDragging) {
            /* Suppress the synthetic click that follows a drag-release
               so the card under the cursor doesn't open the modal. */
            var swallow = function (ev) {
              ev.stopPropagation();
              ev.preventDefault();
              track.removeEventListener('click', swallow, true);
            };
            track.addEventListener('click', swallow, true);

            /* If the pointer paused for longer than 80ms before
               releasing, the user effectively stopped the drag —
               drop any stale velocity so the track doesn't lurch
               on release. Otherwise hand off into inertia. */
            var sinceLast = nowMs() - drag.lastTime;
            if (sinceLast > 80) drag.velocity = 0;
            startInertia(drag.velocity);
          }
        }
        track.addEventListener('pointerup', endDrag);
        track.addEventListener('pointercancel', endDrag);
        /* Don't let images inside the track be picked up as drag-
           images by the browser, which would interrupt the swipe. */
        track.addEventListener('dragstart', function (e) { e.preventDefault(); });
      }

      /* Card click → open modal (same as `mam-product-bioactives`). */
      function openModal(card) {
        if (!modal || !card) return;
        var latin = card.getAttribute('data-bio-latin') || '';
        var common = card.getAttribute('data-bio-common') || '';
        var description = card.getAttribute('data-bio-description') || '';
        var image = card.getAttribute('data-bio-image') || '';
        var tag = card.getAttribute('data-bio-tag') || '';
        var pillBg = card.getAttribute('data-bio-pill-bg') || '';
        var pillText = card.getAttribute('data-bio-pill-text') || '';
        var videoUrl = card.getAttribute('data-bio-video-url') || '';
        var glossaryUrl = card.getAttribute('data-bio-glossary-url') || '';

        var plate = modal.querySelector('[data-mam-bio-car-modal-plate]');
        if (plate) {
          plate.innerHTML = '';
          if (image) {
            var img = document.createElement('img');
            img.src = image;
            img.alt = common || latin;
            plate.appendChild(img);
          }
        }
        var pill = modal.querySelector('[data-mam-bio-car-modal-pill]');
        if (pill) {
          pill.style.backgroundColor = pillBg;
          pill.style.color = pillText;
        }
        var dot = modal.querySelector('[data-mam-bio-car-modal-pill-dot]');
        if (dot) dot.style.backgroundColor = pillText;
        var pillLabel = modal.querySelector('[data-mam-bio-car-modal-pill-label]');
        if (pillLabel) pillLabel.textContent = tag;
        var latinEl = modal.querySelector('[data-mam-bio-car-modal-latin]');
        if (latinEl) latinEl.textContent = latin;
        var commonEl = modal.querySelector('[data-mam-bio-car-modal-common]');
        var commonWrap = modal.querySelector('[data-mam-bio-car-modal-common-wrap]');
        if (common) {
          if (commonEl) commonEl.textContent = common;
          if (commonWrap) commonWrap.style.display = '';
        } else if (commonWrap) {
          commonWrap.style.display = 'none';
        }
        var desc = modal.querySelector('[data-mam-bio-car-modal-description]');
        if (desc) desc.textContent = description;
        /* Toggle visibility on both Watch-video and Full-glossary CTAs
           independently, then flip the matching layout class on the
           actions container:
             - both visible: 2-col grid + divider (default).
             - one visible (.is-single-action): 1-col grid, no divider.
             - neither visible (.is-empty-actions): the row is hidden
               entirely so the bottom of the modal doesn't end with an
               orphan border. */
        var video = modal.querySelector('[data-mam-bio-car-modal-video]');
        if (video) {
          if (videoUrl) {
            video.setAttribute('href', videoUrl);
            video.style.display = '';
          } else {
            video.style.display = 'none';
          }
        }
        var glossary = modal.querySelector('[data-mam-bio-car-modal-glossary]');
        if (glossary) {
          if (glossaryUrl) {
            glossary.setAttribute('href', glossaryUrl);
            glossary.style.display = '';
          } else {
            glossary.style.display = 'none';
          }
        }
        var actionsParent = (video && video.parentElement)
          || (glossary && glossary.parentElement);
        if (actionsParent) {
          var oneVisible = (!!videoUrl) !== (!!glossaryUrl);
          var noneVisible = !videoUrl && !glossaryUrl;
          actionsParent.classList.toggle('is-single-action', oneVisible);
          actionsParent.classList.toggle('is-empty-actions', noneVisible);
        }

        modal.hidden = false;
        document.body.style.overflow = 'hidden';
      }
      /* Embedded player wiring — intercepts the Watch-video link so
         it opens the in-modal player overlay instead of navigating
         off-site. Detects YouTube URLs and emits an `<iframe>`
         pointing at the standard `youtube.com/embed/<id>` endpoint;
         everything else (Shopify uploads, direct mp4/mov URLs) is
         rendered into a native `<video controls>` tag. */
      var playerEl = modal && modal.querySelector('[data-mam-bio-car-modal-player]');
      var playerFrameEl = modal && modal.querySelector('[data-mam-bio-car-modal-player-frame]');
      var playerCloseEl = modal && modal.querySelector('[data-mam-bio-car-modal-player-close]');
      var videoLinkEl = modal && modal.querySelector('[data-mam-bio-car-modal-video]');

      function parseYouTubeIdCar(url) {
        if (!url) return null;
        var m = url.match(
          /(?:youtube\.com\/(?:watch\?(?:.+&)?v=|embed\/|shorts\/|v\/)|youtu\.be\/)([\w-]{11})/
        );
        return m ? m[1] : null;
      }
      function buildEmbedNodeCar(url) {
        var ytId = parseYouTubeIdCar(url);
        if (ytId) {
          var iframe = document.createElement('iframe');
          iframe.src = 'https://www.youtube.com/embed/' + ytId +
            '?autoplay=1&rel=0&playsinline=1';
          iframe.setAttribute(
            'allow',
            'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share'
          );
          iframe.setAttribute('allowfullscreen', '');
          iframe.setAttribute('loading', 'lazy');
          return iframe;
        }
        var v = document.createElement('video');
        v.src = url;
        v.controls = true;
        v.autoplay = true;
        v.playsInline = true;
        v.setAttribute('preload', 'metadata');
        return v;
      }
      function openPlayerCar(url) {
        if (!playerEl || !playerFrameEl || !url) return;
        while (playerFrameEl.firstChild) playerFrameEl.removeChild(playerFrameEl.firstChild);
        playerFrameEl.appendChild(buildEmbedNodeCar(url));
        playerEl.hidden = false;
      }
      function closePlayerCar() {
        if (!playerEl || !playerFrameEl) return;
        playerEl.hidden = true;
        /* Removing the iframe / video child both stops playback and
           frees the network connection (YouTube iframes keep
           streaming until torn down). */
        while (playerFrameEl.firstChild) playerFrameEl.removeChild(playerFrameEl.firstChild);
      }

      if (videoLinkEl) {
        videoLinkEl.addEventListener('click', function (e) {
          e.preventDefault();
          var url = videoLinkEl.getAttribute('href') || '';
          if (url && url !== '#') openPlayerCar(url);
        });
      }
      if (playerCloseEl) {
        playerCloseEl.addEventListener('click', closePlayerCar);
      }

      function closeModal() {
        if (!modal) return;
        closePlayerCar();
        modal.hidden = true;
        document.body.style.overflow = '';
      }

      var cards = root.querySelectorAll('[data-mam-bio-car-card]');
      for (var c = 0; c < cards.length; c++) {
        (function (card) {
          card.addEventListener('click', function () { openModal(card); });
          card.addEventListener('keydown', function (e) {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              openModal(card);
            }
          });
        })(cards[c]);
      }
      if (modal) {
        var closers = modal.querySelectorAll('[data-mam-bio-car-close]');
        for (var k = 0; k < closers.length; k++) {
          closers[k].addEventListener('click', closeModal);
        }
        document.addEventListener('keydown', function (e) {
          if (e.key === 'Escape' && !modal.hidden) closeModal();
        });
      }
    }

    function initAll() {
      var roots = document.querySelectorAll('[data-mam-bioactives-carousel]');
      for (var i = 0; i < roots.length; i++) initSection(roots[i]);
      if (window.MAM) {
        for (var j = 0; j < roots.length; j++) {
          MAM.observeReveals(roots[j]);
          MAM.observeWordReveals(roots[j]);
        }
      }
    }

    ready(initAll);

    document.addEventListener('shopify:section:load', function (e) {
      if (!e.target) return;
      var roots = e.target.querySelectorAll
        ? e.target.querySelectorAll('[data-mam-bioactives-carousel]')
        : [];
      if (e.target.matches && e.target.matches('[data-mam-bioactives-carousel]')) {
        initSection(e.target);
      }
      for (var i = 0; i < roots.length; i++) initSection(roots[i]);
      if (window.MAM) {
        MAM.observeReveals(e.target);
        MAM.observeWordReveals(e.target);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mam-contact"] && !Shopify.designMode) return;
  try {
    
  /* Reveal observers — wires the section's `[data-mam-reveal]` and
     `[data-mam-word-reveal]` hooks into the global MAM controllers
     so the heading + body fade in on viewport entry. */
  (function () {
    if (window.__mamContactInit) return;
    window.__mamContactInit = true;

    function ready(fn) {
      if (document.readyState !== 'loading') fn();
      else document.addEventListener('DOMContentLoaded', fn);
    }

    function init(section) {
      if (!section || section.__mamContactWired) return;
      section.__mamContactWired = true;
      if (window.MAM) {
        MAM.observeReveals(section);
        MAM.observeWordReveals(section);
      }
    }

    ready(function () {
      var roots = document.querySelectorAll('.mam-contact');
      for (var i = 0; i < roots.length; i++) init(roots[i]);
    });

    document.addEventListener('shopify:section:load', function (e) {
      if (e && e.target && e.target.classList
          && e.target.classList.contains('section-mam-contact')) {
        var root = e.target.querySelector('.mam-contact');
        if (root) init(root);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mam-cornish-bloom-benefits"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__mamCBloomBenefitsInit) return;
    window.__mamCBloomBenefitsInit = true;
    function ready(fn) {
      if (document.readyState !== 'loading') fn();
      else document.addEventListener('DOMContentLoaded', fn);
    }
    function init(section) {
      if (!section || section.__mamCBloomBenefitsWired) return;
      section.__mamCBloomBenefitsWired = true;
      if (window.MAM) {
        MAM.observeReveals(section);
        MAM.observeWordReveals(section);
      }
    }
    ready(function () {
      var roots = document.querySelectorAll('.mam-cbloom-benefits');
      for (var i = 0; i < roots.length; i++) init(roots[i]);
    });
    document.addEventListener('shopify:section:load', function (e) {
      if (e && e.target && e.target.classList
          && e.target.classList.contains('section-mam-cbloom-benefits')) {
        var root = e.target.querySelector('.mam-cbloom-benefits');
        if (root) init(root);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mam-cornish-bloom-collage"] && !Shopify.designMode) return;
  try {
    
  /* Marquee-style collage scroller — vanilla JS port of the React
     `CollageScroller` (CornishBloomCollage.tsx). Self-contained per
     section instance, with a single rAF loop that exits when idle. */
  (function () {
    if (window.MAM) {
      var revealScope = document.currentScript ? document.currentScript.parentElement : document;
      MAM.observeReveals(revealScope);
      MAM.observeWordReveals(revealScope);
    }

    if (window.__mamCBloomCollageInit) return;
    window.__mamCBloomCollageInit = true;

    var prefersReducedMotion = window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function wire(section) {
      if (section.__mamCBloomCollageWired) return;
      section.__mamCBloomCollageWired = true;

      var track = section.querySelector('[data-mam-cbloom-collage-track]');
      if (!track) return;

      var rafId = null;
      var lastScroll = 0;
      var target = 0;
      var velocity = 0;       /* drag velocity for release momentum */
      var liveVelocity = 0;   /* live px/frame for tile scale */
      var lastMove = null;
      var lastWrittenScale = 1; /* last `--tile-scale` value we wrote */
      /* `lastJsScrollWrite` tracks the scrollLeft we last set from JS
         (lerp tick or wrap). The scroll event handler compares the
         current scrollLeft against this to tell our own writes apart
         from native scroll (touch swipe / iOS momentum / trackpad).
         When they diverge by more than 2px the scroll is external,
         and we sync `target` so the rAF lerp doesn't fight the
         user's gesture. */
      var lastJsScrollWrite = 0;
      /* `snapped` flips false the moment the user starts a new
         interaction (wheel, drag, touch swipe) and flips true again
         once we've aligned to the nearest column. It guards the
         exit condition in `tick()` so we snap once per gesture and
         then stay put — no jitter-loop between two columns. */
      var snapped = true;
      var drag = { down: false, startX: 0, startScroll: 0, pointerId: -1 };
      var interact = { dragging: false };

      /* Returns the `offsetLeft` of the column whose left edge is
         closest to the given `scrollLeft`. We walk every column —
         including the duplicated marquee half — so the nearest snap
         point is always within ~half a column width regardless of
         where the user lands. */
      function getNearestColumnX(scrollLeft) {
        var cols = track.querySelectorAll('.mam-cbloom-collage__col');
        if (!cols.length) return scrollLeft;
        var closest = scrollLeft;
        var minDist = Infinity;
        for (var i = 0; i < cols.length; i++) {
          var x = cols[i].offsetLeft;
          var dist = Math.abs(x - scrollLeft);
          if (dist < minDist) {
            minDist = dist;
            closest = x;
          }
        }
        return closest;
      }

      var AUTO_SPEED = 0; /* Marquee auto-advance disabled, matches React. */
      var LERP = 0.14;

      /* Toggling `is-scrolling` lets CSS attach `will-change: transform`
         to the 30 tiles only while we're actually scrolling. Keeping
         the property always-on would force the browser to keep a
         persistent compositing layer per tile — fine on desktop, but
         memory-pressure on lower-spec phones. */
      function setScrolling(on) {
        if (on === interact.scrolling) return;
        interact.scrolling = on;
        if (on) track.classList.add('is-scrolling');
        else track.classList.remove('is-scrolling');
      }

      function wrap() {
        var half = track.scrollWidth / 2;
        if (half <= 0) return;
        if (track.scrollLeft >= half) {
          track.scrollLeft -= half;
          target -= half;
          lastJsScrollWrite = track.scrollLeft;
        } else if (track.scrollLeft < 0) {
          track.scrollLeft += half;
          target += half;
          lastJsScrollWrite = track.scrollLeft;
        }
      }

      function tick() {
        if (!track) {
          rafId = null;
          setScrolling(false);
          return;
        }
        if (lastScroll === 0) lastScroll = track.scrollLeft;
        var current = track.scrollLeft;
        var diff = target - current;
        var interacting = interact.dragging;

        if (!interacting) {
          if (Math.abs(diff) > 0.5) {
            track.scrollLeft = current + diff * LERP;
            lastJsScrollWrite = track.scrollLeft;
          } else if (AUTO_SPEED > 0) {
            track.scrollLeft = current + AUTO_SPEED;
            target += AUTO_SPEED;
            lastJsScrollWrite = track.scrollLeft;
          }
          wrap();
        }

        /* Live velocity in px/frame, smoothed for tile-scale var. */
        var instantV = Math.abs(track.scrollLeft - lastScroll);
        liveVelocity = liveVelocity * 0.85 + instantV * 0.15;
        var v = Math.min(liveVelocity, 28);
        var scale = 1 - (v / 28) * 0.035;
        /* Skip the style write when the new scale is within 0.001 of
           the last one — invalidating styles every frame is the main
           cost of the tile-scale effect, and the visual difference
           below that threshold is sub-pixel. */
        if (Math.abs(scale - lastWrittenScale) >= 0.001) {
          track.style.setProperty('--tile-scale', scale.toFixed(4));
          lastWrittenScale = scale;
        }
        lastScroll = track.scrollLeft;

        var stillLerping = Math.abs(diff) > 0.5;
        var stillMoving = liveVelocity > 0.05;
        if (!interact.dragging && !stillLerping && !stillMoving) {
          /* Snap-to-nearest-column on rest. The first time the loop
             would otherwise exit after a user gesture, hand the
             lerp a new target — the offsetLeft of the closest
             column. The flag flips so the next exit (after the snap
             lerp settles) is the real one. */
          if (!snapped) {
            var snapX = getNearestColumnX(track.scrollLeft);
            snapped = true;
            if (Math.abs(snapX - track.scrollLeft) > 2) {
              target = snapX;
              rafId = requestAnimationFrame(tick);
              return;
            }
          }
          /* Reset the scale to exact 1 so tiles don't sit on a
             sub-pixel transform when fully idle (eliminates the
             permanent compositing layer hint). */
          if (lastWrittenScale !== 1) {
            track.style.setProperty('--tile-scale', '1');
            lastWrittenScale = 1;
          }
          setScrolling(false);
          rafId = null;
          return;
        }
        setScrolling(true);
        rafId = requestAnimationFrame(tick);
      }

      function ensureLoop() {
        if (rafId !== null) return;
        if (prefersReducedMotion) return;
        rafId = requestAnimationFrame(tick);
      }

      /* Pointer drag — mouse + pen only. Touch falls through to native
         horizontal scroll so iOS momentum works as expected. */
      track.addEventListener('pointerdown', function (e) {
        if (e.pointerType === 'touch') return;
        interact.dragging = true;
        snapped = false;
        target = track.scrollLeft;
        drag.down = true;
        drag.startX = e.clientX;
        drag.startScroll = track.scrollLeft;
        drag.pointerId = e.pointerId;
        lastMove = { x: e.clientX, t: performance.now() };
        velocity = 0;
        track.classList.add('is-dragging');
        try { track.setPointerCapture(e.pointerId); } catch (err) {}
        ensureLoop();
      });

      track.addEventListener('pointermove', function (e) {
        if (!drag.down) return;
        var dx = e.clientX - drag.startX;
        track.scrollLeft = drag.startScroll - dx;
        target = track.scrollLeft;
        lastJsScrollWrite = track.scrollLeft;
        wrap();
        var now = performance.now();
        var last = lastMove;
        if (last) {
          var dt = now - last.t;
          if (dt > 0) {
            var dxMove = e.clientX - last.x;
            velocity = -dxMove / dt;
          }
        }
        lastMove = { x: e.clientX, t: now };
      });

      function endDrag(e) {
        if (!drag.down) return;
        drag.down = false;
        interact.dragging = false;
        track.classList.remove('is-dragging');
        if (e && track.hasPointerCapture && track.hasPointerCapture(e.pointerId)) {
          try { track.releasePointerCapture(e.pointerId); } catch (err) {}
        }
        var v = velocity;
        velocity = 0;
        if (Math.abs(v) > 0.05) {
          /* Momentum coast — extend target by the last drag velocity
             scaled to a ~320ms throw, then let the lerp loop carry it. */
          target += v * 320;
          ensureLoop();
        }
      }
      track.addEventListener('pointerup', endDrag);
      track.addEventListener('pointercancel', endDrag);
      track.addEventListener('pointerleave', function (e) {
        if (drag.down) endDrag(e);
      });

      /* Wheel — accumulate into target, lerp via the rAF loop.
         `passive: false` so we can preventDefault on horizontal
         intent and on the strip itself. */
      track.addEventListener('wheel', function (e) {
        var horizontal = Math.abs(e.deltaX) > Math.abs(e.deltaY);
        var delta = horizontal ? e.deltaX : e.deltaY;
        e.preventDefault();
        target += delta * 1.1;
        snapped = false;
        ensureLoop();
      }, { passive: false });

      /* Scroll handler — tells our own JS writes (lerp tick, wrap,
         drag) apart from external scroll (touch swipe, iOS momentum,
         trackpad two-finger pan without wheel hook). When the
         current scrollLeft diverges from the last JS write by more
         than 2px the scroll is external, so we sync `target` to
         wherever the user is — otherwise the rAF lerp would yank
         the strip back to a stale target the next frame and the
         swipe would feel sticky / jittery.

         The 2px threshold tolerates sub-pixel rounding from the
         browser while still catching real gestures (a touch
         dragmove is typically 10–80px per scroll event). */
      track.addEventListener('scroll', function () {
        if (interact.dragging) return;
        var sl = track.scrollLeft;
        if (Math.abs(sl - lastJsScrollWrite) > 2) {
          /* External scroll (touch swipe, iOS momentum, trackpad
             pan) — sync target so the lerp doesn't fight the
             gesture, and reset `snapped` so the column-snap fires
             once the momentum settles. */
          target = sl;
          lastJsScrollWrite = sl;
          snapped = false;
        }
        wrap();
        ensureLoop();
      }, { passive: true });

      /* Anchor the initial scroll position to 0 so the first column
         shows on load. */
      track.scrollLeft = 0;
      target = 0;
    }

    function initAll(scope) {
      var sections = (scope || document).querySelectorAll('[data-mam-cbloom-collage]');
      for (var i = 0; i < sections.length; i++) wire(sections[i]);
    }

    if (document.readyState !== 'loading') initAll(document);
    else document.addEventListener('DOMContentLoaded', function () { initAll(document); });

    document.addEventListener('shopify:section:load', function (e) {
      if (e && e.target && e.target.classList
          && e.target.classList.contains('section-mam-cbloom-collage')) {
        initAll(e.target);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mam-cornish-bloom-hero"] && !Shopify.designMode) return;
  try {
    
  /* Per-word reveal + scroll-driven fade & parallax. The fade target
     is the `[data-mam-cbloom-fade]` wrapper that contains every
     visual layer so the whole hero dissolves as one block when the
     user scrolls into the next section. Mirrors the framer-motion
     wiring in the React reference. */
  (function () {
    if (window.MAM) {
      var scope = document.currentScript ? document.currentScript.parentElement : document;
      MAM.observeReveals(scope);
      MAM.observeWordReveals(scope);
    }

    if (window.__mamCBloomHeroInit) return;
    window.__mamCBloomHeroInit = true;

    var reduceMotion = window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function wire(section) {
      if (section.__mamCBloomWired) return;
      section.__mamCBloomWired = true;

      var fadeEl = section.querySelector('[data-mam-cbloom-fade]');
      if (!fadeEl || reduceMotion) return;

      var rafId = 0;
      function update() {
        rafId = 0;
        var rect = section.getBoundingClientRect();
        var height = section.offsetHeight;
        if (height === 0) return;
        var scrolled = -rect.top;
        var progress = scrolled / height;
        if (progress < 0) progress = 0;
        if (progress > 1) progress = 1;

        var opacity;
        if (progress < 0.6) opacity = 1;
        else if (progress >= 0.95) opacity = 0;
        else opacity = 1 - (progress - 0.6) / 0.35;

        var translatePct = -15 * progress;

        fadeEl.style.opacity = opacity.toFixed(3);
        fadeEl.style.transform = 'translate3d(0,' + translatePct.toFixed(2) + '%,0)';
      }

      function schedule() {
        if (!rafId) rafId = requestAnimationFrame(update);
      }

      update();
      window.addEventListener('scroll', schedule, { passive: true });
      window.addEventListener('resize', schedule);
    }

    function initAll(scope) {
      var sections = (scope || document).querySelectorAll('[data-mam-cbloom-hero]');
      for (var i = 0; i < sections.length; i++) wire(sections[i]);
    }

    if (document.readyState !== 'loading') initAll(document);
    else document.addEventListener('DOMContentLoaded', function () { initAll(document); });

    document.addEventListener('shopify:section:load', function (e) {
      if (e && e.target && e.target.classList
          && e.target.classList.contains('section-mam-cbloom-hero')) {
        initAll(e.target);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mam-cornish-framework"] && !Shopify.designMode) return;
  try {
    
  /* Cornish Framework — tabs drive an `is-active` class on the matching
     card. Hovering a sibling card on desktop temporarily reassigns the
     active class without touching the tab state, so the user can preview
     a card and then return to their tab on mouseleave. The
     `is-resolved` class on the cards list gates the desktop dim-others
     styling — added on first frame so the inactive cards don't flash
     dim during initial paint. */
  (function () {
    if (window.__mamCornishFwInit) return;
    window.__mamCornishFwInit = true;

    function ready(fn) {
      if (document.readyState !== 'loading') fn();
      else document.addEventListener('DOMContentLoaded', fn);
    }

    function init(section) {
      if (section.__mamCfwWired) return;
      section.__mamCfwWired = true;

      var tabs = section.querySelectorAll('[data-mam-cfw-tab]');
      var list = section.querySelector('[data-mam-cfw-cards]');
      var cards = section.querySelectorAll('[data-mam-cfw-card]');
      if (!tabs.length || !cards.length || !list) return;

      var activeIdx = 0;
      var hoverIdx = null;

      function paint() {
        var focusIdx = (hoverIdx === null) ? activeIdx : hoverIdx;
        for (var i = 0; i < cards.length; i++) {
          if (i === focusIdx) cards[i].classList.add('is-active');
          else cards[i].classList.remove('is-active');
        }
        for (var j = 0; j < tabs.length; j++) {
          if (j === activeIdx) {
            tabs[j].classList.add('is-active');
            tabs[j].setAttribute('aria-selected', 'true');
          } else {
            tabs[j].classList.remove('is-active');
            tabs[j].setAttribute('aria-selected', 'false');
          }
        }
      }

      function pick(idx) {
        if (idx < 0 || idx >= cards.length) return;
        activeIdx = idx;
        paint();
        /* Scroll the active card into view on mobile (where the row is a
           horizontal scroller). On desktop the grid has no overflow so
           this is a no-op. */
        if (list.scrollWidth > list.clientWidth + 1) {
          var target = cards[idx];
          if (!target) return;
          var next = Math.max(
            0,
            target.offsetLeft - (list.clientWidth - target.offsetWidth) / 2
          );
          /* Sync assignment — scroll-snap fights smooth scrolling here. */
          list.scrollLeft = next;
        }
      }

      for (var i = 0; i < tabs.length; i++) {
        (function (idx, btn) {
          btn.addEventListener('click', function () { pick(idx); });
        })(i, tabs[i]);
      }

      for (var k = 0; k < cards.length; k++) {
        (function (idx, card) {
          card.addEventListener('mouseenter', function () {
            hoverIdx = idx;
            paint();
          });
          card.addEventListener('click', function () { pick(idx); });
        })(k, cards[k]);
      }
      list.addEventListener('mouseleave', function () {
        hoverIdx = null;
        paint();
      });

      /* Mark the cards list as resolved on the next frame so the dim
         styling for inactive desktop cards engages cleanly. */
      requestAnimationFrame(function () {
        list.classList.add('is-resolved');
      });

      paint();
    }

    function initAll(scope) {
      var sections = (scope || document).querySelectorAll('[data-mam-cornish-framework]');
      for (var i = 0; i < sections.length; i++) init(sections[i]);
    }

    ready(function () {
      initAll(document);
      if (window.MAM) {
        MAM.observeReveals(document);
      }
    });

    document.addEventListener('shopify:section:load', function (e) {
      if (e.target && e.target.classList && e.target.classList.contains('section-mam-cornish-fw')) {
        initAll(e.target);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mam-cornish-hero"] && !Shopify.designMode) return;
  try {
    
  if (window.MAM) {
    var scope = document.currentScript ? document.currentScript.parentElement : document;
    MAM.observeReveals(scope);
    MAM.observeWordReveals(scope);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mam-ecosystems-flow"] && !Shopify.designMode) return;
  try {
    
  if (window.MAM) {
    var scope = document.currentScript ? document.currentScript.parentElement : document;
    MAM.observeReveals(scope);
    MAM.observeWordReveals(scope);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mam-ecosystems-tabs"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__mamEcotabsInit) return;
    window.__mamEcotabsInit = true;

    function ready(fn) {
      if (document.readyState !== 'loading') fn();
      else document.addEventListener('DOMContentLoaded', fn);
    }

    function initSection(root) {
      if (!root || root.__mamEcotabsBound) return;
      root.__mamEcotabsBound = true;

      var tabs = root.querySelectorAll('[data-mam-ecotabs-tab]');
      var panels = root.querySelectorAll('[data-mam-ecotabs-panel]');
      var pill = root.querySelector('[data-mam-ecotabs-pill]');

      function setActive(slug) {
        if (!slug) return;
        root.setAttribute('data-active-lens', slug);
        var dark = false;
        var wash = '';
        for (var i = 0; i < tabs.length; i++) {
          var btn = tabs[i];
          var active = btn.getAttribute('data-mam-ecotabs-tab') === slug;
          btn.classList.toggle('is-active', active);
          btn.setAttribute('aria-selected', active ? 'true' : 'false');
          if (active) {
            wash = btn.getAttribute('data-wash') || '';
            dark = btn.getAttribute('data-dark') === 'true';
          }
        }
        for (var j = 0; j < panels.length; j++) {
          var p = panels[j];
          var on = p.getAttribute('data-mam-ecotabs-panel') === slug;
          p.classList.toggle('is-active', on);
          p.setAttribute('aria-hidden', on ? 'false' : 'true');
          /* Pause any video that's playing inside a panel that's
             being deactivated, so audio/CPU doesn't keep running
             behind the curtain after a lens swap. */
          if (!on) {
            var vids = p.querySelectorAll('[data-mam-ecotabs-video]');
            for (var v = 0; v < vids.length; v++) {
              if (!vids[v].paused) vids[v].pause();
            }
          }
        }
        root.classList.toggle('is-dark', dark);
        var textColor = dark ? 'var(--mam-cream, #F5EDE4)' : 'var(--mam-ink, #1A1A1A)';
        if (wash) root.style.backgroundColor = wash;
        root.style.color = textColor;

        /* Sync any element marked `data-mam-ecotabs-sync` (e.g. the
           statement section sitting directly above the framework on
           the /collections page). Mirrors React's lifted-lens state
           where the statement + framework share one wash. The synced
           element gets the same bg/text plus a `data-mam-ecotabs-dark`
           attribute so its own CSS can flip token-driven sub-elements
           (e.g. the statement headline colour). */
        var synced = document.querySelectorAll('[data-mam-ecotabs-sync]');
        for (var s = 0; s < synced.length; s++) {
          var el = synced[s];
          if (wash) el.style.backgroundColor = wash;
          el.style.color = textColor;
          el.setAttribute('data-mam-ecotabs-dark', dark ? 'true' : 'false');
          /* Override the statement section's `--mam-statement-color`
             (set inline by mam-statement.liquid) so the headline
             colour actually flips with the surface. */
          el.style.setProperty('--mam-statement-color', textColor);
        }
      }

      for (var k = 0; k < tabs.length; k++) {
        (function (btn) {
          btn.addEventListener('click', function () {
            setActive(btn.getAttribute('data-mam-ecotabs-tab'));
          });
          btn.addEventListener('keydown', function (e) {
            if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
            e.preventDefault();
            var current = -1;
            for (var i = 0; i < tabs.length; i++) {
              if (tabs[i] === document.activeElement) { current = i; break; }
            }
            if (current === -1) return;
            var next = e.key === 'ArrowRight' ? (current + 1) % tabs.length : (current - 1 + tabs.length) % tabs.length;
            tabs[next].focus();
            setActive(tabs[next].getAttribute('data-mam-ecotabs-tab'));
          });
        })(tabs[k]);
      }

      /* Per-card video toggle. Click the video OR the play overlay to
         start; click again (or click another card's video) to pause.
         The card gets `is-playing` while rolling so the play overlay
         fades out. Only one video can play at a time within a panel —
         clicking play on a second card pauses any sibling that's
         already running. */
      var cards = root.querySelectorAll('[data-mam-ecotabs-card]');
      for (var c = 0; c < cards.length; c++) {
        (function (card) {
          if (card.__mamEcotabsCardBound) return;
          card.__mamEcotabsCardBound = true;
          var video = card.querySelector('[data-mam-ecotabs-video]');
          var playBtn = card.querySelector('[data-mam-ecotabs-play]');
          if (!video) return;

          function pauseSiblings() {
            var panel = card.closest('[data-mam-ecotabs-panel]');
            if (!panel) return;
            var others = panel.querySelectorAll('[data-mam-ecotabs-video]');
            for (var i = 0; i < others.length; i++) {
              if (others[i] !== video && !others[i].paused) others[i].pause();
            }
          }
          function toggle() {
            if (video.paused) {
              pauseSiblings();
              var p = video.play();
              if (p && typeof p.catch === 'function') p.catch(function () {});
            } else {
              video.pause();
            }
          }

          video.addEventListener('click', toggle);
          if (playBtn) playBtn.addEventListener('click', toggle);
          video.addEventListener('play', function () {
            card.classList.add('is-playing');
            if (playBtn) playBtn.setAttribute('aria-label', 'Pause video');
          });
          video.addEventListener('pause', function () {
            card.classList.remove('is-playing');
            if (playBtn) {
              var origLabel = playBtn.getAttribute('data-orig-label');
              if (!origLabel) {
                origLabel = playBtn.getAttribute('aria-label') || 'Play video';
                playBtn.setAttribute('data-orig-label', origLabel);
              }
              playBtn.setAttribute('aria-label', origLabel);
            }
          });
          video.addEventListener('ended', function () {
            card.classList.remove('is-playing');
          });
        })(cards[c]);
      }

      /* Initial sync — push the default lens's wash + text colour
         into every `[data-mam-ecotabs-sync]` element on the page.
         The framework's own bg is already correct (set inline
         server-side from `default_wash`), but the statement section
         above carries the merchant's hardcoded `bg_color` setting
         which won't match the active lens unless we sync. Disable
         transition during this first paint so synced elements snap
         rather than fade in from the wrong colour. */
      var initialActiveTab = root.querySelector('[data-mam-ecotabs-tab].is-active');
      if (initialActiveTab) {
        var syncedInit = document.querySelectorAll('[data-mam-ecotabs-sync]');
        for (var si = 0; si < syncedInit.length; si++) {
          syncedInit[si].style.transition = 'none';
        }
        setActive(initialActiveTab.getAttribute('data-mam-ecotabs-tab'));
        /* Force layout flush, then clear the inline transition so
           subsequent tab clicks fade with the section's CSS rule. */
        // eslint-disable-next-line no-unused-expressions
        document.body.offsetHeight;
        for (var sj = 0; sj < syncedInit.length; sj++) {
          syncedInit[sj].style.transition = '';
        }
      }
    }

    function initAll() {
      var roots = document.querySelectorAll('[data-mam-ecotabs]');
      for (var i = 0; i < roots.length; i++) initSection(roots[i]);
      if (window.MAM) {
        for (var j = 0; j < roots.length; j++) {
          MAM.observeReveals(roots[j]);
          MAM.observeWordReveals(roots[j]);
        }
      }
    }

    ready(initAll);

    document.addEventListener('shopify:section:load', function (e) {
      if (!e.target) return;
      var roots = e.target.querySelectorAll
        ? e.target.querySelectorAll('[data-mam-ecotabs]')
        : [];
      if (e.target.matches && e.target.matches('[data-mam-ecotabs]')) {
        initSection(e.target);
      }
      for (var i = 0; i < roots.length; i++) initSection(roots[i]);
      if (window.MAM) {
        MAM.observeReveals(e.target);
        MAM.observeWordReveals(e.target);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mam-editorial-split"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__mamEdSplitInit) return;
    window.__mamEdSplitInit = true;

    function ready(fn) {
      if (document.readyState !== 'loading') fn();
      else document.addEventListener('DOMContentLoaded', fn);
    }

    ready(function () {
      if (!window.MAM) return;
      var roots = document.querySelectorAll('.mam-edsplit');
      for (var i = 0; i < roots.length; i++) {
        MAM.observeReveals(roots[i]);
        MAM.observeWordReveals(roots[i]);
      }
    });

    document.addEventListener('shopify:section:load', function (e) {
      if (e && e.target && window.MAM) {
        MAM.observeReveals(e.target);
        MAM.observeWordReveals(e.target);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mam-education-grid"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__mamEduGridInit) return;
    window.__mamEduGridInit = true;

    function ready(fn) {
      if (document.readyState !== 'loading') fn();
      else document.addEventListener('DOMContentLoaded', fn);
    }

    function init(root) {
      if (!root || root.__mamEduGridWired) return;
      root.__mamEduGridWired = true;

      var pills = root.querySelectorAll('[data-mam-edu-grid-pill]');
      var items = root.querySelectorAll('[data-mam-edu-grid-item]');
      var moreBtn = root.querySelector('[data-mam-edu-grid-more]');
      var emptyState = root.querySelector('[data-mam-edu-grid-empty]');
      var pageSize = parseInt(root.getAttribute('data-page-size'), 10) || 6;

      if (!items.length) return;

      var activeCategory = 'all';
      var visibleCount = pageSize;

      function applyVisibility() {
        var matchingTotal = 0;
        var shown = 0;

        /* Two passes: first count matches, then mark items
           hidden-by-page once we've revealed `visibleCount`
           matches. This keeps the load-more behaviour pinned to
           the FILTERED set, not the raw total — clicking
           "Research" with 12 research posts means page 1 shows
           6 research posts, not 6 of the 6 closest published
           posts that happen to be research. */
        for (var i = 0; i < items.length; i++) {
          var cat = items[i].getAttribute('data-category') || '';
          var matchesFilter = activeCategory === 'all' || cat === activeCategory;
          if (!matchesFilter) {
            items[i].classList.add('is-hidden-by-filter');
            items[i].classList.remove('is-hidden-by-page');
          } else {
            items[i].classList.remove('is-hidden-by-filter');
            matchingTotal++;
            if (shown < visibleCount) {
              items[i].classList.remove('is-hidden-by-page');
              shown++;
            } else {
              items[i].classList.add('is-hidden-by-page');
            }
          }
        }

        if (moreBtn) {
          if (matchingTotal > shown) moreBtn.hidden = false;
          else moreBtn.hidden = true;
        }
        if (emptyState) {
          emptyState.hidden = matchingTotal !== 0;
        }
      }

      for (var p = 0; p < pills.length; p++) {
        (function (pill) {
          pill.addEventListener('click', function () {
            var cat = pill.getAttribute('data-category') || 'all';
            if (cat === activeCategory) return;
            activeCategory = cat;
            /* Reset the page window every time the filter
               changes — the user should always start a fresh
               filter from the top of that set. */
            visibleCount = pageSize;
            for (var k = 0; k < pills.length; k++) {
              if (pills[k] === pill) {
                pills[k].classList.add('is-active');
                pills[k].setAttribute('aria-selected', 'true');
              } else {
                pills[k].classList.remove('is-active');
                pills[k].setAttribute('aria-selected', 'false');
              }
            }
            applyVisibility();
          });
        })(pills[p]);
      }

      if (moreBtn) {
        moreBtn.addEventListener('click', function () {
          visibleCount += pageSize;
          applyVisibility();
        });
      }

      applyVisibility();

      if (window.MAM) {
        MAM.observeReveals(root);
        MAM.observeWordReveals(root);
      }
    }

    function initAll(scope) {
      var roots = (scope || document).querySelectorAll('[data-mam-edu-grid]');
      for (var i = 0; i < roots.length; i++) init(roots[i]);
    }

    ready(function () { initAll(document); });
    document.addEventListener('shopify:section:load', function (e) {
      if (e.target) initAll(e.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mam-education-hero"] && !Shopify.designMode) return;
  try {
    
  if (window.MAM) {
    var scope = document.currentScript ? document.currentScript.parentElement : document;
    MAM.observeReveals(scope);
    MAM.observeWordReveals(scope);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mam-education-latest"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__mamEduLatestInit) return;
    window.__mamEduLatestInit = true;

    function ready(fn) {
      if (document.readyState !== 'loading') fn();
      else document.addEventListener('DOMContentLoaded', fn);
    }

    function pad(n) {
      return n < 10 ? '0' + n : String(n);
    }

    function init(root) {
      if (!root || root.__mamEduLatestWired) return;
      root.__mamEduLatestWired = true;

      var slides = root.querySelectorAll('[data-mam-edu-latest-slide]');
      var dots = root.querySelectorAll('[data-mam-edu-latest-dot]');
      var prev = root.querySelector('[data-mam-edu-latest-prev]');
      var next = root.querySelector('[data-mam-edu-latest-next]');
      var counter = root.querySelector('[data-mam-edu-latest-counter]');
      if (!slides.length) return;

      var current = 0;

      /* Crossfade between slides by toggling `is-active`. The CSS
         transitions handle the opacity + 12px y-translate. Counter
         + dots + aria-hidden flip in lockstep. */
      function setSlide(idx) {
        if (idx < 0) idx = slides.length - 1;
        if (idx >= slides.length) idx = 0;
        current = idx;
        for (var i = 0; i < slides.length; i++) {
          if (i === idx) {
            slides[i].classList.add('is-active');
            slides[i].setAttribute('aria-hidden', 'false');
          } else {
            slides[i].classList.remove('is-active');
            slides[i].setAttribute('aria-hidden', 'true');
          }
        }
        for (var d = 0; d < dots.length; d++) {
          if (d === idx) {
            dots[d].classList.add('is-active');
            dots[d].setAttribute('aria-selected', 'true');
          } else {
            dots[d].classList.remove('is-active');
            dots[d].setAttribute('aria-selected', 'false');
          }
        }
        if (counter) {
          counter.textContent = pad(idx + 1) + ' / ' + pad(slides.length);
        }
      }

      if (prev) prev.addEventListener('click', function () { setSlide(current - 1); });
      if (next) next.addEventListener('click', function () { setSlide(current + 1); });
      for (var d = 0; d < dots.length; d++) {
        (function (i) {
          dots[i].addEventListener('click', function () { setSlide(i); });
        })(d);
      }

      /* Initial counter so it always shows e.g. "01 / 04" even
         when the server-rendered fallback string had a different
         total. */
      setSlide(0);

      if (window.MAM) {
        MAM.observeReveals(root);
        MAM.observeWordReveals(root);
      }
    }

    function initAll(scope) {
      var roots = (scope || document).querySelectorAll('[data-mam-edu-latest]');
      for (var i = 0; i < roots.length; i++) init(roots[i]);
    }

    ready(function () { initAll(document); });
    document.addEventListener('shopify:section:load', function (e) {
      if (e.target) initAll(e.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mam-faq"] && !Shopify.designMode) return;
  try {
    
  /* FAQ accordion — toggles `[data-open]` on the answer wrapper and
     mirrors `aria-expanded` on the button. Uses the grid-template-rows
     0fr → 1fr CSS technique for the height animation, so no
     per-element height measurement is needed.

     The reveal observers (`MAM.observeReveals` /
     `MAM.observeWordReveals`) get wired up once on initial load and
     re-wired whenever the section is reloaded in the theme editor. */
  (function () {
    if (window.__mamFaqInit) return;
    window.__mamFaqInit = true;

    function ready(fn) {
      if (document.readyState !== 'loading') fn();
      else document.addEventListener('DOMContentLoaded', fn);
    }

    function wireToggle(btn) {
      if (btn.__mamFaqWired) return;
      btn.__mamFaqWired = true;
      btn.addEventListener('click', function () {
        var expanded = btn.getAttribute('aria-expanded') === 'true';
        var controlsId = btn.getAttribute('aria-controls');
        var wrap = controlsId ? document.getElementById(controlsId) : null;
        btn.setAttribute('aria-expanded', expanded ? 'false' : 'true');
        if (wrap) {
          if (expanded) wrap.removeAttribute('data-open');
          else wrap.setAttribute('data-open', '');
        }
      });
    }

    function init(scope) {
      if (!scope) return;
      var toggles = scope.querySelectorAll('.mam-faq__toggle');
      for (var i = 0; i < toggles.length; i++) wireToggle(toggles[i]);
      if (window.MAM) {
        MAM.observeReveals(scope);
        MAM.observeWordReveals(scope);
      }
    }

    ready(function () { init(document); });

    document.addEventListener('shopify:section:load', function (e) {
      if (e && e.target && e.target.classList
          && e.target.classList.contains('section-mam-faq')) {
        init(e.target);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mam-framework"] && !Shopify.designMode) return;
  try {
    
  /* Framework — ecosystem-tab driven. Scrolling within an ecosystem
     drives the stage progression (cross-fade through that
     ecosystem's stages and bg tint interpolation). Clicking an
     ecosystem tab swaps the visible set of stages, the accent
     colour and the meta colour, and re-arms the scroll-pinned
     scaffold so the user can experience that ecosystem's run-once
     cycle independently. */
  (function () {
    if (window.__mamFrameworkInit) return;
    window.__mamFrameworkInit = true;

    var REDUCED_MOTION_QUERY = '(prefers-reduced-motion: reduce)';
    var MOBILE_QUERY = '(max-width: 1023px)';

    function ready(fn) {
      if (document.readyState !== 'loading') fn();
      else document.addEventListener('DOMContentLoaded', fn);
    }
    function clamp(v, lo, hi) { return v < lo ? lo : v > hi ? hi : v; }

    function parseHex(c) {
      if (!c || typeof c !== 'string') return null;
      var s = c.trim();
      if (s.charAt(0) !== '#') return null;
      if (s.length === 4) {
        s = '#' + s[1] + s[1] + s[2] + s[2] + s[3] + s[3];
      }
      if (s.length !== 7) return null;
      var r = parseInt(s.slice(1, 3), 16);
      var g = parseInt(s.slice(3, 5), 16);
      var b = parseInt(s.slice(5, 7), 16);
      if (isNaN(r) || isNaN(g) || isNaN(b)) return null;
      return [r, g, b];
    }
    function lerpColor(a, b, t) {
      if (!a || !b) return null;
      var r = Math.round(a[0] + (b[0] - a[0]) * t);
      var g = Math.round(a[1] + (b[1] - a[1]) * t);
      var bl = Math.round(a[2] + (b[2] - a[2]) * t);
      return 'rgb(' + r + ',' + g + ',' + bl + ')';
    }

    function init(root) {
      if (root.__mamFrameworkInited) return;
      root.__mamFrameworkInited = true;

      var scroll = root.querySelector('[data-mam-framework-scroll]');
      if (!scroll) return;

      /* Honour `data-bg-override` — when set, lock the section bg
         and skip every scroll-driven `root.style.backgroundColor`
         write so the per-stage tint interpolation is bypassed.
         Mirrors React's `bgOverride` on FrameworkStages. */
      var bgOverride = root.getAttribute('data-bg-override') || '';
      if (bgOverride) {
        root.style.backgroundColor = bgOverride;
      }
      function paintRoot(c) {
        if (bgOverride) return;
        root.style.backgroundColor = c;
      }

      /* `tabs` is the ecosystem-tab set used for ecosystem switching;
         `stageTabs` is populated only in stage-tab mode (product
         page), where each tab carries its 0-indexed stage index and
         click jumps directly to that stage within the active
         ecosystem. */
      var tabMode = root.getAttribute('data-tab-mode') || 'ecosystems';
      var tabs = root.querySelectorAll('[data-mam-framework-eco]');
      var stageTabs = root.querySelectorAll('[data-mam-framework-stage-tab]');
      var allDots = root.querySelectorAll('[data-mam-framework-dot]');
      var allCopies = root.querySelectorAll('[data-mam-framework-copy]');
      var allVisuals = root.querySelectorAll('[data-mam-framework-visual]');
      var prevBtn = root.querySelector('[data-mam-framework-prev]');
      var nextBtn = root.querySelector('[data-mam-framework-next]');
      var prevBtnDesktop = root.querySelector('[data-mam-framework-prev-desktop]');
      var nextBtnDesktop = root.querySelector('[data-mam-framework-next-desktop]');
      var counterEl = root.querySelector('[data-mam-framework-counter]');
      var totalEl = root.querySelector('[data-mam-framework-total]');
      var mobileDots = root.querySelectorAll('[data-mam-framework-dot-mobile]');

      var activeEco = root.getAttribute('data-active-eco') || 'cornish';
      var activeIdx = 0;
      var reducedMotion = window.matchMedia(REDUCED_MOTION_QUERY).matches;
      /* Flat mode — when set (via the `disable_desktop_scroll`
         schema setting) the section behaves as if we're always on
         mobile: scroll-pinned scaffold is bypassed, stage tab
         clicks just swap the active stage without triggering a
         page scroll. Used on the product page where the intro-
         style scroll progression is unwanted. */
      var flatMode = root.getAttribute('data-flat') === 'true';
      /* Mobile flag — when true, scroll-pinned scaffold is bypassed
         and stages are tap/swipe-driven. Updated on resize so a
         viewport rotation switches modes correctly. `flatMode`
         forces this on at every viewport. */
      var mobileMql = window.matchMedia(MOBILE_QUERY);
      var isMobile = mobileMql.matches || flatMode;
      var completed = false;

      /* Active per-ecosystem subsets. Recomputed on every ecosystem
         switch so the scroll progression and bg interpolation only
         consider the visible stages. */
      var activeDots = [];
      var activeCopies = [];
      var activeVisuals = [];
      var rgbList = [];
      var stageCount = 0;

      function recomputeActiveSets() {
        activeDots = [];
        activeCopies = [];
        activeVisuals = [];
        rgbList = [];
        for (var i = 0; i < allDots.length; i++) {
          if (allDots[i].getAttribute('data-stage-eco') === activeEco) activeDots.push(allDots[i]);
        }
        for (var j = 0; j < allCopies.length; j++) {
          if (allCopies[j].getAttribute('data-stage-eco') === activeEco) activeCopies.push(allCopies[j]);
        }
        for (var k = 0; k < allVisuals.length; k++) {
          if (allVisuals[k].getAttribute('data-stage-eco') === activeEco) {
            activeVisuals.push(allVisuals[k]);
            rgbList.push(parseHex(allVisuals[k].getAttribute('data-stage-bg')));
          }
        }
        stageCount = activeVisuals.length;
        root.style.setProperty('--stage-count', stageCount || 1);
        if (totalEl) {
          totalEl.textContent = (stageCount < 10 ? '0' : '') + stageCount;
        }
      }

      function applyEcoVisibility() {
        for (var i = 0; i < allDots.length; i++) {
          allDots[i].classList.toggle('is-eco-hidden', allDots[i].getAttribute('data-stage-eco') !== activeEco);
        }
        for (var j = 0; j < allCopies.length; j++) {
          allCopies[j].classList.toggle('is-eco-hidden', allCopies[j].getAttribute('data-stage-eco') !== activeEco);
        }
        for (var k = 0; k < allVisuals.length; k++) {
          allVisuals[k].classList.toggle('is-eco-hidden', allVisuals[k].getAttribute('data-stage-eco') !== activeEco);
        }
      }

      function paintTabs() {
        /* Ecosystem tabs — active when slug matches activeEco. */
        for (var i = 0; i < tabs.length; i++) {
          var on = tabs[i].getAttribute('data-mam-framework-eco') === activeEco;
          tabs[i].classList.toggle('is-active', on);
          tabs[i].setAttribute('aria-selected', on ? 'true' : 'false');
        }
        /* Stage tabs — active when index matches activeIdx within
           the current ecosystem. */
        for (var s = 0; s < stageTabs.length; s++) {
          var idx = parseInt(stageTabs[s].getAttribute('data-mam-framework-stage-tab'), 10);
          var sOn = (idx === activeIdx);
          stageTabs[s].classList.toggle('is-active', sOn);
          stageTabs[s].setAttribute('aria-selected', sOn ? 'true' : 'false');
        }
      }

      function applyAccentFromActiveTab() {
        var btn = root.querySelector('[data-mam-framework-eco="' + activeEco + '"]');
        if (!btn) return;
        var accent = btn.getAttribute('data-eco-accent');
        var meta = btn.getAttribute('data-eco-meta');
        if (accent) root.style.setProperty('--mam-framework-accent', accent);
        if (meta) root.style.setProperty('--mam-framework-meta', meta);
      }

      function setActive(idx) {
        idx = clamp(idx, 0, Math.max(0, stageCount - 1));
        if (idx === activeIdx) return;
        activeIdx = idx;
        applyActiveClasses();
        updateCounter();
        updateNavDisabled();
      }
      function applyActiveClasses() {
        for (var i = 0; i < activeDots.length; i++) {
          activeDots[i].classList.toggle('is-active', i === activeIdx);
        }
        for (var j = 0; j < activeCopies.length; j++) {
          activeCopies[j].classList.toggle('is-active', j === activeIdx);
        }
        for (var k = 0; k < activeVisuals.length; k++) {
          activeVisuals[k].classList.toggle('is-active', k === activeIdx);
        }
        /* Repaint the tab strip — needed so stage-mode tabs update
           their is-active state as the user scrolls through stages
           (ecosystem-mode tabs are unaffected because activeEco
           hasn't changed). */
        paintTabs();
        pauseInactiveVideos();
      }
      function pauseInactiveVideos() {
        for (var i = 0; i < allVisuals.length; i++) {
          var isActive = i < allVisuals.length
            && allVisuals[i].getAttribute('data-stage-eco') === activeEco
            && activeVisuals[activeIdx] === allVisuals[i];
          var v = allVisuals[i].querySelector('[data-mam-framework-video]');
          if (v && !isActive && !v.paused) v.pause();
          if (!isActive) allVisuals[i].classList.remove('is-playing');
        }
      }
      /* Wire per-stage video toggles once. Videos in inactive
         ecosystems just stay paused — pauseInactiveVideos handles
         pausing on switch. */
      for (var vi = 0; vi < allVisuals.length; vi++) {
        (function (visual) {
          var video = visual.querySelector('[data-mam-framework-video]');
          var playBtn = visual.querySelector('[data-mam-framework-play]');
          if (!video) return;
          function toggle() {
            if (video.paused) {
              var p = video.play();
              if (p && typeof p.catch === 'function') p.catch(function () {});
            } else {
              video.pause();
            }
          }
          video.style.cursor = 'pointer';
          video.addEventListener('click', toggle);
          if (playBtn) {
            playBtn.setAttribute('data-play-label', playBtn.getAttribute('aria-label') || 'Play video');
            playBtn.setAttribute('data-pause-label', 'Pause video');
            playBtn.addEventListener('click', toggle);
          }
          video.addEventListener('play', function () {
            visual.classList.add('is-playing');
            if (playBtn) playBtn.setAttribute('aria-label', playBtn.getAttribute('data-pause-label') || 'Pause video');
          });
          video.addEventListener('pause', function () {
            visual.classList.remove('is-playing');
            if (playBtn) playBtn.setAttribute('aria-label', playBtn.getAttribute('data-play-label') || 'Play video');
          });
          video.addEventListener('ended', function () {
            visual.classList.remove('is-playing');
          });
        })(allVisuals[vi]);
      }

      function updateCounter() {
        if (counterEl) {
          var n = activeIdx + 1;
          counterEl.textContent = (n < 10 ? '0' : '') + n;
        }
        /* Sync the mobile dot rail — the active dot grows and
           fills cornish-deep, others stay small + muted. */
        for (var pi = 0; pi < mobileDots.length; pi++) {
          var idx = parseInt(mobileDots[pi].getAttribute('data-mam-framework-dot-mobile') || '0', 10);
          var on = idx === activeIdx;
          mobileDots[pi].classList.toggle('is-active', on);
          mobileDots[pi].setAttribute('aria-selected', on ? 'true' : 'false');
        }
      }
      function updateNavDisabled() {
        var atFirst = activeIdx <= 0;
        var atLast = activeIdx >= stageCount - 1;
        if (prevBtn) {
          prevBtn.disabled = atFirst;
          prevBtn.setAttribute('aria-disabled', atFirst ? 'true' : 'false');
        }
        if (nextBtn) {
          nextBtn.disabled = atLast;
          nextBtn.setAttribute('aria-disabled', atLast ? 'true' : 'false');
        }
        if (prevBtnDesktop) {
          prevBtnDesktop.disabled = atFirst;
          prevBtnDesktop.setAttribute('aria-disabled', atFirst ? 'true' : 'false');
          prevBtnDesktop.classList.toggle('is-disabled', atFirst);
        }
        if (nextBtnDesktop) {
          nextBtnDesktop.disabled = atLast;
          nextBtnDesktop.setAttribute('aria-disabled', atLast ? 'true' : 'false');
          nextBtnDesktop.classList.toggle('is-disabled', atLast);
        }
      }
      function applyBgFromProgress(p) {
        if (!rgbList.length || rgbList.length !== stageCount) return;
        var segments = stageCount - 1;
        if (segments <= 0) return;
        var seg = clamp(p * segments, 0, segments);
        var idx = Math.floor(seg);
        var t = seg - idx;
        if (idx >= segments) { idx = segments - 1; t = 1; }
        var a = rgbList[idx];
        var b = rgbList[idx + 1];
        if (a && b) paintRoot(lerpColor(a, b, t));
      }

      var scrollDirty = true;
      var rafId = 0;
      function onScroll() {
        if (rafId) return;
        scrollDirty = true;
        rafId = requestAnimationFrame(tick);
      }
      function tick() {
        rafId = 0;
        if (!scrollDirty) return;
        scrollDirty = false;
        /* Mobile bypasses scroll-driven activation entirely — stages
           are tap/swipe-driven via the mobile-nav strip. Just keep
           the bg in sync with the active stage so it doesn't flash
           a stale value when the user enters the section. */
        if (isMobile) {
          var mrgb = rgbList[activeIdx];
          if (mrgb) paintRoot('rgb(' + mrgb[0] + ',' + mrgb[1] + ',' + mrgb[2] + ')');
          return;
        }
        if (completed) {
          var rgb = rgbList[activeIdx];
          if (rgb) paintRoot('rgb(' + rgb[0] + ',' + rgb[1] + ',' + rgb[2] + ')');
          return;
        }
        var rect = scroll.getBoundingClientRect();
        var scrollable = scroll.offsetHeight - window.innerHeight;
        if (scrollable <= 0 || stageCount <= 0) return;
        var p = clamp(-rect.top / scrollable, 0, 1);
        var idx = clamp(Math.floor(p * stageCount), 0, stageCount - 1);
        if (idx !== activeIdx) setActive(idx);
        applyBgFromProgress(p);
        if (rect.bottom <= 0) markCompleted();
      }
      function markCompleted() {
        if (completed) return;
        completed = true;
        var oldHeight = scroll.offsetHeight;
        var oldScrollY = window.scrollY;
        root.classList.add('is-completed');
        var newHeight = scroll.offsetHeight;
        var delta = oldHeight - newHeight;
        if (delta > 0) {
          var target = Math.max(0, oldScrollY - delta);
          var scrollEl = document.scrollingElement || document.documentElement;
          if (scrollEl) scrollEl.scrollTop = target;
          window.scrollTo({ top: target });
          if (window.__lenis && typeof window.__lenis.scrollTo === 'function') {
            window.__lenis.scrollTo(target, { immediate: true });
          }
        }
      }

      function jumpTo(idx) {
        idx = clamp(idx, 0, stageCount - 1);
        /* On mobile / reduced-motion / post-completion, bypass scroll
           animation and just swap the active classes + bg. */
        if (isMobile || reducedMotion || completed) {
          setActive(idx);
          var rgb = rgbList[idx];
          if (rgb) paintRoot('rgb(' + rgb[0] + ',' + rgb[1] + ',' + rgb[2] + ')');
          return;
        }
        var rect = scroll.getBoundingClientRect();
        var sectionTop = rect.top + window.scrollY;
        var scrollable = scroll.offsetHeight - window.innerHeight;
        if (scrollable <= 0) { setActive(idx); return; }
        var targetProgress = (idx + 0.5) / stageCount;
        var target = sectionTop + scrollable * targetProgress;
        if (window.__lenis) {
          window.__lenis.scrollTo(target, { duration: 1.2 });
        } else {
          window.scrollTo({ top: target, behavior: 'smooth' });
        }
      }

      /* Switch the active ecosystem. Re-arms the scroll-pinned
         scaffold (clears `completed`) so the user can experience
         the new ecosystem's stages at their own pace. */
      function switchEco(slug) {
        if (slug === activeEco) return;
        activeEco = slug;
        root.setAttribute('data-active-eco', slug);
        if (completed) {
          completed = false;
          root.classList.remove('is-completed');
        }
        recomputeActiveSets();
        applyEcoVisibility();
        applyAccentFromActiveTab();
        paintTabs();
        activeIdx = clamp(activeIdx, 0, Math.max(0, stageCount - 1));
        applyActiveClasses();
        updateCounter();
        updateNavDisabled();
        /* Re-paint bg from current scroll position (or first
           stage's bg if no scroll progress). */
        onScroll();
      }

      /* Wire interactions. */
      for (var t = 0; t < tabs.length; t++) {
        (function (btn) {
          btn.addEventListener('click', function () {
            switchEco(btn.getAttribute('data-mam-framework-eco'));
          });
        })(tabs[t]);
      }
      /* Stage tabs (product-page mode) — click jumps the
         scroll-pinned scaffold to the matching stage within the
         active ecosystem. */
      for (var st = 0; st < stageTabs.length; st++) {
        (function (btn) {
          btn.addEventListener('click', function () {
            var idx = parseInt(btn.getAttribute('data-mam-framework-stage-tab'), 10);
            if (!isNaN(idx)) jumpTo(idx);
          });
        })(stageTabs[st]);
      }
      /* Dot rail click — jump to that stage WITHIN the active eco.
         Uses the activeDots index, not the global dot index. */
      for (var d = 0; d < allDots.length; d++) {
        (function (btn) {
          btn.addEventListener('click', function () {
            var idx = activeDots.indexOf(btn);
            if (idx >= 0) jumpTo(idx);
          });
        })(allDots[d]);
      }
      if (prevBtn) prevBtn.addEventListener('click', function () { jumpTo(activeIdx - 1); });
      if (nextBtn) nextBtn.addEventListener('click', function () { jumpTo(activeIdx + 1); });
      if (prevBtnDesktop) prevBtnDesktop.addEventListener('click', function () { jumpTo(activeIdx - 1); });
      if (nextBtnDesktop) nextBtnDesktop.addEventListener('click', function () { jumpTo(activeIdx + 1); });

      /* Mobile dot-rail — clicking any dot jumps directly to that
         stage. Mirrors the React reference where each dot is a
         tappable target, not just a status indicator. */
      for (var md = 0; md < mobileDots.length; md++) {
        (function (dot) {
          dot.addEventListener('click', function () {
            var idx = parseInt(dot.getAttribute('data-mam-framework-dot-mobile') || '0', 10);
            jumpTo(idx);
          });
        })(mobileDots[md]);
      }

      /* Mobile swipe gesture — horizontal pointer drag on the
         visual + copy stack advances/rewinds the active stage.
         Threshold of 50px before a swipe registers, matching the
         React reference. Vertical drags are ignored so the page
         can still scroll. */
      var cols = root.querySelector('.mam-framework__cols');
      var swipeStartX = null;
      var swipeStartY = null;
      if (cols) {
        cols.addEventListener('pointerdown', function (e) {
          if (!isMobile) return;
          swipeStartX = e.clientX;
          swipeStartY = e.clientY;
        });
        cols.addEventListener('pointerup', function (e) {
          if (!isMobile || swipeStartX === null) return;
          var dx = e.clientX - swipeStartX;
          var dy = e.clientY - swipeStartY;
          swipeStartX = null;
          swipeStartY = null;
          /* Ignore primarily-vertical drags so they read as page
             scroll, not stage swipes. */
          if (Math.abs(dy) > Math.abs(dx)) return;
          if (Math.abs(dx) < 50) return;
          if (dx < 0 && activeIdx < stageCount - 1) jumpTo(activeIdx + 1);
          else if (dx > 0 && activeIdx > 0) jumpTo(activeIdx - 1);
        });
        cols.addEventListener('pointercancel', function () {
          swipeStartX = null;
          swipeStartY = null;
        });
      }

      /* React to viewport changes — orientation flip, browser
         resize across the 768px breakpoint, etc. Re-toggles isMobile
         and re-paints. Flat mode locks the flag on so viewport
         changes never re-arm the scroll-pinned scaffold. */
      function handleMqlChange() {
        if (flatMode) return;
        var nextMobile = mobileMql.matches;
        if (nextMobile === isMobile) return;
        isMobile = nextMobile;
        /* When entering mobile mode, ensure no stale `is-completed`
           collapses the layout further. The CSS already collapses
           on mobile via media query so the class is harmless, but
           keeping the desktop bg + completed flag fresh makes the
           switch back to desktop predictable. */
        if (isMobile) {
          var rgb = rgbList[activeIdx];
          if (rgb) paintRoot('rgb(' + rgb[0] + ',' + rgb[1] + ',' + rgb[2] + ')');
        } else {
          onScroll();
        }
      }
      if (mobileMql.addEventListener) {
        mobileMql.addEventListener('change', handleMqlChange);
      } else if (mobileMql.addListener) {
        mobileMql.addListener(handleMqlChange);
      }

      var resizeRaf = 0;
      window.addEventListener('resize', function () {
        if (resizeRaf) cancelAnimationFrame(resizeRaf);
        resizeRaf = requestAnimationFrame(onScroll);
      });

      /* Listen for the in-page anchor jump signal (fired by the
         hero star-rating click, etc.). Collapse the scaffold so
         a caller scrolling past the section isn't trapped in the
         pinned window. No-op when we're already flat / completed. */
      document.addEventListener('mam:collapse-scroll', function () {
        if (flatMode || isMobile) return;
        markCompleted();
      });

      /* Initial paint — compute active sets, paint tabs, kick off
         scroll. */
      recomputeActiveSets();
      applyAccentFromActiveTab();
      paintTabs();
      applyActiveClasses();
      updateCounter();
      updateNavDisabled();
      if (!reducedMotion) {
        window.addEventListener('scroll', onScroll, { passive: true });
        onScroll();
      }
    }

    function initAll(scope) {
      var roots = (scope || document).querySelectorAll('[data-mam-framework]');
      for (var i = 0; i < roots.length; i++) init(roots[i]);
    }
    ready(function () { initAll(document); });
    document.addEventListener('shopify:section:load', function (e) {
      if (e.target && e.target.classList && e.target.classList.contains('section-mam-framework')) {
        initAll(e.target);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mam-glossary-item"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__mamGitemInit) return;
    window.__mamGitemInit = true;

    function ready(fn) {
      if (document.readyState !== 'loading') fn();
      else document.addEventListener('DOMContentLoaded', fn);
    }

    function init(section) {
      if (!section || section.__mamGitemWired) return;
      section.__mamGitemWired = true;
      if (window.MAM) {
        MAM.observeReveals(section);
        MAM.observeWordReveals(section);
      }
    }

    ready(function () {
      var roots = document.querySelectorAll('.mam-gitem');
      for (var i = 0; i < roots.length; i++) init(roots[i]);
    });

    document.addEventListener('shopify:section:load', function (e) {
      if (e && e.target && e.target.classList
          && e.target.classList.contains('section-mam-glossary-item')) {
        var root = e.target.querySelector('.mam-gitem');
        if (root) init(root);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mam-glossary"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__mamGlossaryInit) return;
    window.__mamGlossaryInit = true;

    function ready(fn) {
      if (document.readyState !== 'loading') fn();
      else document.addEventListener('DOMContentLoaded', fn);
    }

    function init(section) {
      if (!section || section.__mamGlossaryWired) return;
      section.__mamGlossaryWired = true;
      if (window.MAM) {
        MAM.observeReveals(section);
        MAM.observeWordReveals(section);
      }
    }

    ready(function () {
      var roots = document.querySelectorAll('.mam-glossary');
      for (var i = 0; i < roots.length; i++) init(roots[i]);
    });

    document.addEventListener('shopify:section:load', function (e) {
      if (e && e.target && e.target.classList
          && e.target.classList.contains('section-mam-glossary')) {
        var root = e.target.querySelector('.mam-glossary');
        if (root) init(root);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mam-hero-compact"] && !Shopify.designMode) return;
  try {
    
  if (window.MAM) {
    MAM.observeReveals(document.currentScript ? document.currentScript.parentElement : document);
    MAM.observeWordReveals(document.currentScript ? document.currentScript.parentElement : document);
  }

  /* Scroll-indicator click — smoothly scrolls past the hero to
     the next section. Prefers Lenis (the site-wide smooth-scroll
     driver) when present so the motion matches every other in-
     page anchor; falls back to native `scroll-behavior: smooth`
     via `window.scrollTo`. */
  (function () {
    var scope = document.currentScript ? document.currentScript.parentElement : document;
    var btn = scope.querySelector('[data-mam-hero-compact-scroll]');
    if (!btn) return;
    btn.addEventListener('click', function () {
      var hero = btn.closest('.mam-hero-compact');
      if (!hero) return;
      var target = hero.getBoundingClientRect().bottom + window.scrollY;
      if (window.__lenis && typeof window.__lenis.scrollTo === 'function') {
        window.__lenis.scrollTo(target, { duration: 1.2 });
      } else {
        window.scrollTo({ top: target, behavior: 'smooth' });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mam-hero"] && !Shopify.designMode) return;
  try {
    
  if (window.MAM) {
    MAM.observeReveals(document.currentScript ? document.currentScript.parentElement : document);
    MAM.observeWordReveals(document.currentScript ? document.currentScript.parentElement : document);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mam-instagram-grid"] && !Shopify.designMode) return;
  try {
    
  /* Instagram grid — modal open/close + body scroll lock + ESC handler.
     Each tile button carries the post's image / alt / caption / post
     URL as data attributes; the modal re-uses a single shared markup
     (per section) and rewires its content on open. */
  (function () {
    if (window.__mamInstaInit) return;
    window.__mamInstaInit = true;

    function ready(fn) {
      if (document.readyState !== 'loading') fn();
      else document.addEventListener('DOMContentLoaded', fn);
    }

    function bind(section) {
      if (section.__mamInstaWired) return;
      section.__mamInstaWired = true;

      var sectionId = section.id.replace('mam-insta-', '');
      var modal = document.getElementById('mam-insta-modal-' + sectionId);
      if (!modal) return;

      var img = modal.querySelector('img');
      var captionEl = modal.querySelector('[data-mam-insta-caption-target]');
      var linkEl = modal.querySelector('[data-mam-insta-link]');
      var profileFallback = section.getAttribute('data-mam-insta-profile') || '#';

      function open(trigger) {
        if (img) {
          img.src = trigger.getAttribute('data-mam-insta-image') || '';
          img.alt = trigger.getAttribute('data-mam-insta-alt') || '';
        }
        if (captionEl) captionEl.textContent = trigger.getAttribute('data-mam-insta-caption') || '';
        if (linkEl) {
          var url = trigger.getAttribute('data-mam-insta-url');
          linkEl.href = (url && url.length) ? url : profileFallback;
        }
        modal.removeAttribute('hidden');
        /* Reflow so the opacity transition runs from 0 → 1. */
        void modal.offsetHeight;
        modal.classList.add('is-open');
        document.documentElement.classList.add('mam-insta-modal-open');
        /* Move focus to the close button for keyboard users. */
        var closeBtn = modal.querySelector('[data-mam-insta-close]:not(.mam-insta-modal__backdrop)');
        if (closeBtn && closeBtn.focus) closeBtn.focus();
      }

      function close() {
        modal.classList.remove('is-open');
        document.documentElement.classList.remove('mam-insta-modal-open');
        /* Wait out the fade before unmounting so closing reads smoothly. */
        setTimeout(function () {
          if (!modal.classList.contains('is-open')) {
            modal.setAttribute('hidden', '');
          }
        }, 320);
      }

      section.addEventListener('click', function (e) {
        var trigger = e.target.closest && e.target.closest('[data-mam-insta-open]');
        if (!trigger) return;
        open(trigger);
      });

      modal.addEventListener('click', function (e) {
        var target = e.target;
        if (!target || !target.closest) return;
        if (target.closest('[data-mam-insta-close]')) close();
      });

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && modal.classList.contains('is-open')) close();
      });
    }

    function bindAll(scope) {
      var sections = (scope || document).querySelectorAll('[data-mam-section].mam-insta');
      for (var i = 0; i < sections.length; i++) bind(sections[i]);
    }

    ready(function () {
      bindAll(document);
      if (window.MAM) {
        MAM.observeReveals(document);
        MAM.observeWordReveals(document);
      }
    });

    document.addEventListener('shopify:section:load', function (e) {
      if (e.target && e.target.classList && e.target.classList.contains('section-mam-insta')) {
        bindAll(e.target);
        if (window.MAM) {
          MAM.observeReveals(e.target);
          MAM.observeWordReveals(e.target);
        }
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mam-klaviyo-form"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__mamKlaviyoInit) return;
    window.__mamKlaviyoInit = true;

    function ready(fn) {
      if (document.readyState !== 'loading') fn();
      else document.addEventListener('DOMContentLoaded', fn);
    }

    function init(section) {
      if (!section || section.__mamKlaviyoWired) return;
      section.__mamKlaviyoWired = true;
      if (window.MAM) {
        MAM.observeReveals(section);
        MAM.observeWordReveals(section);
      }
    }

    ready(function () {
      var roots = document.querySelectorAll('.mam-klaviyo');
      for (var i = 0; i < roots.length; i++) init(roots[i]);
    });

    document.addEventListener('shopify:section:load', function (e) {
      if (e && e.target && e.target.classList
          && e.target.classList.contains('section-mam-klaviyo')) {
        var root = e.target.querySelector('.mam-klaviyo');
        if (root) init(root);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mam-microgreens-cta"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__mamMgrnCtaInit) return;
    window.__mamMgrnCtaInit = true;
    function ready(fn) {
      if (document.readyState !== 'loading') fn();
      else document.addEventListener('DOMContentLoaded', fn);
    }
    function init(section) {
      if (!section || section.__mamMgrnCtaWired) return;
      section.__mamMgrnCtaWired = true;
      if (window.MAM) {
        MAM.observeReveals(section);
        MAM.observeWordReveals(section);
      }
    }
    ready(function () {
      var roots = document.querySelectorAll('.mam-mgrn-cta');
      for (var i = 0; i < roots.length; i++) init(roots[i]);
    });
    document.addEventListener('shopify:section:load', function (e) {
      if (e && e.target && e.target.classList
          && e.target.classList.contains('section-mam-mgrn-cta')) {
        var root = e.target.querySelector('.mam-mgrn-cta');
        if (root) init(root);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mam-microgreens-steps"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__mamMgrnStepsInit) return;
    window.__mamMgrnStepsInit = true;
    function ready(fn) {
      if (document.readyState !== 'loading') fn();
      else document.addEventListener('DOMContentLoaded', fn);
    }
    function init(section) {
      if (!section || section.__mamMgrnStepsWired) return;
      section.__mamMgrnStepsWired = true;
      if (window.MAM) {
        MAM.observeReveals(section);
        MAM.observeWordReveals(section);
      }
    }
    ready(function () {
      var roots = document.querySelectorAll('.mam-mgrn-steps');
      for (var i = 0; i < roots.length; i++) init(roots[i]);
    });
    document.addEventListener('shopify:section:load', function (e) {
      if (e && e.target && e.target.classList
          && e.target.classList.contains('section-mam-mgrn-steps')) {
        var root = e.target.querySelector('.mam-mgrn-steps');
        if (root) init(root);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mam-microgreens-video"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__mamMgrnVideoInit) return;
    window.__mamMgrnVideoInit = true;
    function ready(fn) {
      if (document.readyState !== 'loading') fn();
      else document.addEventListener('DOMContentLoaded', fn);
    }
    function init(section) {
      if (!section || section.__mamMgrnVideoWired) return;
      section.__mamMgrnVideoWired = true;
      if (window.MAM) {
        MAM.observeReveals(section);
        MAM.observeWordReveals(section);
      }
    }
    ready(function () {
      var roots = document.querySelectorAll('.mam-mgrn-video');
      for (var i = 0; i < roots.length; i++) init(roots[i]);
    });
    document.addEventListener('shopify:section:load', function (e) {
      if (e && e.target && e.target.classList
          && e.target.classList.contains('section-mam-mgrn-video')) {
        var root = e.target.querySelector('.mam-mgrn-video');
        if (root) init(root);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mam-our-story"] && !Shopify.designMode) return;
  try {
    
  /* Section observer wiring. Runs once on first load and re-runs
     when Shopify re-injects the section in the theme editor so
     the per-word headline + fade-up paragraph reveals fire on
     freshly-rendered nodes. */
  (function () {
    if (window.__mamOurStoryInit) return;
    window.__mamOurStoryInit = true;

    function ready(fn) {
      if (document.readyState !== 'loading') fn();
      else document.addEventListener('DOMContentLoaded', fn);
    }
    function observe(scope) {
      if (!scope || !window.MAM) return;
      MAM.observeReveals(scope);
      MAM.observeWordReveals(scope);
    }
    ready(function () { observe(document); });
    document.addEventListener('shopify:section:load', function (e) {
      if (e && e.target && e.target.classList
          && e.target.classList.contains('section-mam-our-story')) {
        observe(e.target);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mam-policies"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__mamPoliciesInit) return;
    window.__mamPoliciesInit = true;

    function ready(fn) {
      if (document.readyState !== 'loading') fn();
      else document.addEventListener('DOMContentLoaded', fn);
    }

    function init(section) {
      if (!section || section.__mamPoliciesWired) return;
      section.__mamPoliciesWired = true;
      if (window.MAM) {
        MAM.observeReveals(section);
        MAM.observeWordReveals(section);
      }
    }

    ready(function () {
      var roots = document.querySelectorAll('.mam-policies');
      for (var i = 0; i < roots.length; i++) init(roots[i]);
    });

    document.addEventListener('shopify:section:load', function (e) {
      if (e && e.target && e.target.classList
          && e.target.classList.contains('section-mam-policies')) {
        var root = e.target.querySelector('.mam-policies');
        if (root) init(root);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mam-process-cards"] && !Shopify.designMode) return;
  try {
    
  /* Scroll-pinned arc carousel for the Process Cards section.
     Mirrors the Next.js ProcessCards component: each card is positioned
     along the perimeter of a large circle, the carousel rotates as you
     scroll the section, the centre card is "active", and the panel copy
     below cross-fades on each step change. */
  (function () {
    if (window.__mamProcessInit) return;
    window.__mamProcessInit = true;

    /* Arc geometry — keep in sync with Next.js reference. */
    var ANGLE_PER_STEP_DEG = 22;
    var ANGLE_PER_STEP_RAD = (ANGLE_PER_STEP_DEG * Math.PI) / 180;
    var ARC_RADIUS = 1050; /* px */
    var STAGE_VH = 0.65;   /* matches --mam-process-stage-vh */

    var prefersReducedMotion =
      window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    /* Spring-smoothed value used to drive the arc — cheaper than framer
       motion's spring but visually similar. We track velocity and integrate
       toward the raw scroll-derived target each frame. */
    function makeSpring(initial) {
      var value = initial;
      var velocity = 0;
      var stiffness = 140;
      var damping = 28;
      var mass = 0.35;
      return {
        step: function (target, dt) {
          var force = -stiffness * (value - target);
          var dampingForce = -damping * velocity;
          var accel = (force + dampingForce) / mass;
          velocity += accel * dt;
          value += velocity * dt;
          if (Math.abs(velocity) < 0.001 && Math.abs(value - target) < 0.001) {
            value = target;
            velocity = 0;
          }
          return value;
        },
        get: function () { return value; },
        set: function (v) { value = v; velocity = 0; }
      };
    }

    function clamp(v, lo, hi) {
      return v < lo ? lo : (v > hi ? hi : v);
    }

    function init(root) {
      if (root.__mamProcessInited) return;
      root.__mamProcessInited = true;
      var pin = root.querySelector('[data-mam-process-pin]');
      if (!pin) return;
      var cards = Array.prototype.slice.call(
        pin.querySelectorAll('[data-mam-process-card]')
      );
      var panels = Array.prototype.slice.call(
        pin.querySelectorAll('[data-mam-process-panel-item]')
      );
      var stepCount = parseInt(pin.getAttribute('data-step-count'), 10) || cards.length;
      if (stepCount <= 1 || cards.length === 0) return;

      var prevBtn = root.querySelector('[data-mam-process-prev]');
      var nextBtn = root.querySelector('[data-mam-process-next]');

      var spring = makeSpring(0);
      var lastFrame = 0;
      var rafId = 0;
      var targetCenter = 0;
      var activeIdx = 0;
      var scrollDirty = true;
      /* Run-once flag — flips to `true` after the section has been
         fully scrolled past once. While truthy, `readScroll` bails
         and the scroll-pinned scaffold is collapsed by CSS so the
         arc doesn't replay on subsequent scrolls past the section. */
      var completed = false;

      /* Programmatic step navigation — used by the prev/next arrows.
         Mirrors the React `scrollToStep`: target progress is
         idx / (stepCount - 1) of the section's scrollable range.
         Post-completion the scaffold is collapsed (no scroll budget),
         so we spring the arc directly to the target stage instead. */
      function scrollToStep(idx) {
        var clamped = clamp(idx, 0, stepCount - 1);
        if (completed) {
          targetCenter = clamped;
          if (!rafId) {
            lastFrame = 0;
            rafId = requestAnimationFrame(tick);
          }
          return;
        }
        var rect = root.getBoundingClientRect();
        var sectionTop = rect.top + window.scrollY;
        var scrollable = root.offsetHeight - window.innerHeight;
        if (scrollable <= 0) return;
        var targetProgress = clamped / Math.max(1, stepCount - 1);
        var target = sectionTop + scrollable * targetProgress;
        if (window.__lenis && typeof window.__lenis.scrollTo === 'function') {
          window.__lenis.scrollTo(target, { duration: 1.0 });
        } else {
          window.scrollTo({ top: target, behavior: 'smooth' });
        }
      }
      function updateNavDisabled() {
        if (prevBtn) {
          var atStart = activeIdx <= 0;
          prevBtn.disabled = atStart;
          prevBtn.setAttribute('aria-disabled', atStart ? 'true' : 'false');
        }
        if (nextBtn) {
          var atEnd = activeIdx >= stepCount - 1;
          nextBtn.disabled = atEnd;
          nextBtn.setAttribute('aria-disabled', atEnd ? 'true' : 'false');
        }
      }
      if (prevBtn) prevBtn.addEventListener('click', function () { scrollToStep(activeIdx - 1); });
      if (nextBtn) nextBtn.addEventListener('click', function () { scrollToStep(activeIdx + 1); });

      /* Compute the raw center index from current scroll position.
         Once `completed`, the section's pinned scaffold is bypassed
         (either collapsed on mobile post-run, or static on desktop
         by default) — leave `targetCenter` untouched so whichever
         path set it last (mobile-completion parks the last stage;
         desktop-init leaves it at 0) keeps control of the arc, and
         prev/next continue to work via the spring rather than via
         scroll. */
      function readScroll() {
        if (completed) return;
        var rect = root.getBoundingClientRect();
        var scrollable = root.offsetHeight - window.innerHeight;
        if (scrollable <= 0) {
          targetCenter = 0;
          return;
        }
        var scrolled = -rect.top;
        var p = clamp(scrolled / scrollable, 0, 1);
        targetCenter = p * (stepCount - 1);
        /* End-of-section detector: when the section's bottom edge
           crosses the viewport top, the user has scrolled all the
           way through. Mark completed and let CSS collapse the
           scaffold so re-scrolling past won't replay the arc. */
        if (rect.bottom <= 0) markCompleted();
      }

      /* Collapse the section to a single viewport once played. The
         height delta is compensated synchronously so the user's
         viewport doesn't visibly jump — matches the framework
         section's run-once collapse. */
      function markCompleted() {
        if (completed) return;
        completed = true;
        var oldHeight = root.offsetHeight;
        var oldScrollY = window.scrollY;
        root.classList.add('is-completed');
        var newHeight = root.offsetHeight;
        var delta = oldHeight - newHeight;
        if (delta > 0) {
          var target = Math.max(0, oldScrollY - delta);
          var scrollEl = document.scrollingElement || document.documentElement;
          if (scrollEl) scrollEl.scrollTop = target;
          window.scrollTo({ top: target });
          if (window.__lenis && typeof window.__lenis.scrollTo === 'function') {
            window.__lenis.scrollTo(target, { immediate: true });
          }
        }
        /* Lock the arc + active state to the last stage so the
           collapsed section reads as "you've reached the end". */
        targetCenter = stepCount - 1;
        spring.set(stepCount - 1);
        applyArc(stepCount - 1);
        updateActive(stepCount - 1);
      }

      function applyArc(center) {
        for (var i = 0; i < cards.length; i++) {
          var card = cards[i];
          var theta = (i - center) * ANGLE_PER_STEP_RAD;
          var x = ARC_RADIUS * Math.sin(theta);
          var y = ARC_RADIUS * (1 - Math.cos(theta));
          var rot = (i - center) * ANGLE_PER_STEP_DEG;
          var d = Math.abs(i - center);
          var opacity;
          if (d <= 1) opacity = 1 - d * 0.35;
          else opacity = Math.max(0, 0.65 - (d - 1) * 0.9);
          var scale = Math.max(0.78, 1 - d * 0.08);
          card.style.setProperty('--card-x', x + 'px');
          card.style.setProperty('--card-y', y + 'px');
          card.style.setProperty('--card-rot', rot + 'deg');
          card.style.setProperty('--card-scale', scale.toFixed(3));
          card.style.setProperty('--card-opacity', opacity.toFixed(3));
        }

        var idx = clamp(Math.round(center), 0, stepCount - 1);
        if (idx !== activeIdx) {
          updateActive(idx);
        }
      }

      function updateActive(next) {
        var prev = activeIdx;
        activeIdx = next;
        for (var i = 0; i < cards.length; i++) {
          if (i === next) cards[i].classList.add('is-active');
          else cards[i].classList.remove('is-active');
        }
        for (var j = 0; j < panels.length; j++) {
          var panel = panels[j];
          if (j === next) {
            /* Clear any stale leaving state without animating. */
            panel.classList.remove('is-leaving');
            panel.removeAttribute('aria-hidden');
            /* Force a reflow so the browser registers the inactive base
               position before we add is-active and animate up. */
            void panel.offsetWidth;
            panel.classList.add('is-active');
          } else if (j === prev) {
            panel.classList.remove('is-active');
            panel.classList.add('is-leaving');
            panel.setAttribute('aria-hidden', 'true');
          } else {
            panel.classList.remove('is-active');
            panel.classList.remove('is-leaving');
            panel.setAttribute('aria-hidden', 'true');
          }
        }
        updateNavDisabled();
      }

      function tick(now) {
        if (!lastFrame) lastFrame = now;
        var dt = Math.min((now - lastFrame) / 1000, 0.05);
        lastFrame = now;
        if (scrollDirty) {
          readScroll();
          scrollDirty = false;
        }
        var current = spring.step(targetCenter, dt);
        applyArc(current);
        var settled =
          Math.abs(current - targetCenter) < 0.0008 &&
          Math.abs(spring.get() - targetCenter) < 0.0008;
        if (!settled) {
          rafId = requestAnimationFrame(tick);
        } else {
          rafId = 0;
          lastFrame = 0;
        }
      }

      function schedule() {
        scrollDirty = true;
        if (!rafId) {
          lastFrame = 0;
          rafId = requestAnimationFrame(tick);
        }
      }

      /* Static layout for reduced motion — bail out of all scroll work. */
      if (prefersReducedMotion) {
        for (var k = 0; k < panels.length; k++) {
          panels[k].classList.add('is-active');
          panels[k].removeAttribute('aria-hidden');
        }
        return;
      }

      /* Desktop: start in "completed" mode so the scroll-pinned
         scaffold is bypassed entirely. The CSS already renders the
         section at one viewport tall with the pin in static flow on
         (min-width: 768px), and setting `completed = true` here means
         `readScroll()` bails immediately and prev/next drives the arc
         directly via the spring. We deliberately DON'T add the
         `.is-completed` class (its CSS is mobile-only now) or call
         `markCompleted()` (that path is for the mobile "user just
         finished scrolling through" case and parks the arc on the
         last stage). On desktop we start on stage 0 instead. */
      var isDesktop = window.matchMedia &&
        window.matchMedia('(min-width: 768px)').matches;
      if (isDesktop) {
        completed = true;
      }

      /* Initial paint — synchronously read scroll, set spring to target,
         and apply the arc so cards land on their starting positions
         before the first user scroll. */
      readScroll();
      spring.set(targetCenter);
      applyArc(targetCenter);
      updateActive(clamp(Math.round(targetCenter), 0, stepCount - 1));

      window.addEventListener('scroll', schedule, { passive: true });
      window.addEventListener('resize', schedule);
      root.__mamProcessCleanup = function () {
        window.removeEventListener('scroll', schedule);
        window.removeEventListener('resize', schedule);
        if (rafId) cancelAnimationFrame(rafId);
      };

      /* Touch-swipe shortcut — advances by one stage's worth of scroll
         distance so the existing scroll-driven arc plays naturally. */
      var swipeStartX = null;
      pin.addEventListener('pointerdown', function (e) {
        if (e.pointerType !== 'touch') return;
        swipeStartX = e.clientX;
      });
      pin.addEventListener('pointerup', function (e) {
        if (e.pointerType !== 'touch' || swipeStartX === null) return;
        var dx = e.clientX - swipeStartX;
        swipeStartX = null;
        if (Math.abs(dx) < 50) return;
        var stageScroll = window.innerHeight * STAGE_VH;
        var dir = dx < 0 ? 1 : -1;
        var target = window.scrollY + dir * stageScroll;
        if (window.__lenis) {
          window.__lenis.scrollTo(target, { duration: 0.9 });
        } else {
          window.scrollTo({ top: target, behavior: 'smooth' });
        }
      });
      pin.addEventListener('pointercancel', function () {
        swipeStartX = null;
      });

      schedule();
    }

    function initAll(scope) {
      var roots = (scope || document).querySelectorAll('.mam-process');
      for (var i = 0; i < roots.length; i++) init(roots[i]);
    }

    function ready(fn) {
      if (document.readyState !== 'loading') fn();
      else document.addEventListener('DOMContentLoaded', fn);
    }

    ready(function () {
      initAll(document);
      if (window.MAM) {
        MAM.observeWordReveals(document);
      }
    });

    /* Theme editor — re-init when this section is reloaded, and tear
       down listeners when it's unloaded so we don't leak handlers on
       detached nodes. */
    document.addEventListener('shopify:section:load', function (e) {
      if (e.target && e.target.classList && e.target.classList.contains('section-mam-process')) {
        initAll(e.target);
        if (window.MAM) MAM.observeWordReveals(e.target);
      }
    });
    document.addEventListener('shopify:section:unload', function (e) {
      if (!e.target || !e.target.classList || !e.target.classList.contains('section-mam-process')) return;
      var roots = e.target.querySelectorAll('.mam-process');
      for (var i = 0; i < roots.length; i++) {
        if (roots[i].__mamProcessCleanup) roots[i].__mamProcessCleanup();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mam-product-artist"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__mamArtistInit) return;
    window.__mamArtistInit = true;
    function ready(fn) {
      if (document.readyState !== 'loading') fn();
      else document.addEventListener('DOMContentLoaded', fn);
    }
    function wire(section) {
      if (section.__mamArtistWired) return;
      section.__mamArtistWired = true;
      var btn = section.querySelector('[data-mam-artist-play]');
      var video = section.querySelector('[data-mam-artist-video]');
      if (!btn || !video) return;
      btn.addEventListener('click', function () {
        section.classList.add('is-playing');
        var p = video.play();
        if (p && typeof p.catch === 'function') p.catch(function () {});
      });
      video.addEventListener('pause', function () {
        if (video.ended) section.classList.remove('is-playing');
      });
      video.addEventListener('ended', function () {
        section.classList.remove('is-playing');
      });
    }
    function wireAll(scope) {
      var roots = (scope || document).querySelectorAll('[data-mam-artist-notes]');
      for (var i = 0; i < roots.length; i++) wire(roots[i]);
    }
    ready(function () { wireAll(document); });
    document.addEventListener('shopify:section:load', function (e) {
      if (e.target && e.target.classList && e.target.classList.contains('section-mam-artist')) {
        wireAll(e.target);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mam-product-benefits"] && !Shopify.designMode) return;
  try {
    
  /* Adaptive Benefits — flip-on-tap on mobile + scroll-snap dot
     indicator tracking. Hover-to-flip is handled in CSS for pointer-
     fine devices; this JS is purely the touch fallback. */
  (function () {
    if (window.__mamBenefitsInit) return;
    window.__mamBenefitsInit = true;

    function ready(fn) {
      if (document.readyState !== 'loading') fn();
      else document.addEventListener('DOMContentLoaded', fn);
    }

    function init(root) {
      if (root.__mamBenefitsInited) return;
      root.__mamBenefitsInited = true;

      var cards = root.querySelectorAll('[data-mam-benefits-card]');
      var track = root.querySelector('[data-mam-benefits-track]');
      var dots = root.querySelectorAll('[data-mam-benefits-dot]');

      /* Tap-to-flip on touch / coarse-pointer devices. The flip button
         inside each card toggles `is-flipped` on the parent <li>. CSS
         translates that into a 180° rotateY on the panel. */
      for (var i = 0; i < cards.length; i++) {
        (function (card) {
          var btn = card.querySelector('[data-mam-benefits-flip]');
          if (!btn) return;
          btn.addEventListener('click', function () {
            var nowFlipped = !card.classList.contains('is-flipped');
            card.classList.toggle('is-flipped', nowFlipped);
            btn.setAttribute('aria-pressed', nowFlipped ? 'true' : 'false');
          });
        })(cards[i]);
      }

      /* Mobile dot tracking — snaps the active dot to the most centred
         card. Tapping a dot scrolls its card into view. Inert on
         desktop (the track is a CSS grid, not a scroller, so
         scrollLeft is always 0). */
      function paintDots(idx) {
        for (var i = 0; i < dots.length; i++) {
          var on = (i === idx);
          dots[i].classList.toggle('is-active', on);
          dots[i].setAttribute('aria-selected', on ? 'true' : 'false');
        }
      }
      function activeIdxFromScroll() {
        if (!track || !cards.length) return 0;
        var center = track.scrollLeft + track.clientWidth / 2;
        var bestIdx = 0;
        var bestDist = Infinity;
        for (var i = 0; i < cards.length; i++) {
          var c = cards[i];
          var cCenter = c.offsetLeft + c.offsetWidth / 2;
          var d = Math.abs(center - cCenter);
          if (d < bestDist) { bestDist = d; bestIdx = i; }
        }
        return bestIdx;
      }
      var scrollRaf = 0;
      function onScroll() {
        if (scrollRaf) return;
        scrollRaf = requestAnimationFrame(function () {
          scrollRaf = 0;
          paintDots(activeIdxFromScroll());
        });
      }
      if (track) track.addEventListener('scroll', onScroll, { passive: true });
      for (var d = 0; d < dots.length; d++) {
        (function (idx, btn) {
          btn.addEventListener('click', function () {
            var card = cards[idx];
            if (!card || !track) return;
            var target = card.offsetLeft - (track.clientWidth - card.offsetWidth) / 2;
            track.scrollTo({ left: target, behavior: 'smooth' });
          });
        })(d, dots[d]);
      }

      paintDots(0);

      if (window.MAM) {
        MAM.observeReveals(root);
        MAM.observeWordReveals(root);
      }
    }

    function initAll(scope) {
      var roots = (scope || document).querySelectorAll('[data-mam-benefits]');
      for (var i = 0; i < roots.length; i++) init(roots[i]);
    }
    ready(function () { initAll(document); });
    document.addEventListener('shopify:section:load', function (e) {
      if (e.target && e.target.classList && e.target.classList.contains('section-mam-product-benefits')) {
        initAll(e.target);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mam-product-bioactives"] && !Shopify.designMode) return;
  try {
    
  /* Bioactives — three-tab filter + click-to-open modal. Each card
     carries the modal's content as data attributes, so the modal is a
     single shared element that's repopulated on each open. */
  (function () {
    if (window.__mamBioactivesInit) return;
    window.__mamBioactivesInit = true;

    function ready(fn) {
      if (document.readyState !== 'loading') fn();
      else document.addEventListener('DOMContentLoaded', fn);
    }

    function wire(section) {
      if (section.__mamBioactivesWired) return;
      section.__mamBioactivesWired = true;
      var tabs = section.querySelectorAll('[data-mam-tab]');
      var items = section.querySelectorAll('[data-mam-bio-tab]');
      var cards = section.querySelectorAll('[data-mam-bio-card]');
      var viewer = section.querySelector('[data-mam-bio-viewer]');
      var grid = section.querySelector('[data-mam-bio-grid]');
      var prevBtn = section.querySelector('[data-mam-bio-prev]');
      var nextBtn = section.querySelector('[data-mam-bio-next]');
      var initial = section.getAttribute('data-default-tab') || 'primary';

      var sectionId = section.id.replace('bioactives', '').replace(/^-+|-+$/g, '');
      /* Modal lives outside the section, find by id pattern. */
      var modal = document.querySelector('[data-mam-bio-modal]');
      /* Multiple bioactives sections on a page — narrow to the one whose
         id matches this section. The id was rendered with section.id. */
      var allModals = document.querySelectorAll('[data-mam-bio-modal]');
      for (var m = 0; m < allModals.length; m++) {
        if (allModals[m].id === 'mam-bio-modal-' + sectionId.replace(/^-+|-+$/g, '')) {
          modal = allModals[m];
          break;
        }
      }
      /* Fallback: just take the first modal — there's usually only one
         bioactives section per page. */
      if (!modal) modal = allModals[0];

      /* Swiper mode is now permanent — every tab + breakpoint gets
         the horizontal reel. CSS `justify-content: safe center` keeps
         small sets centred until they overflow, then they scroll
         normally. */
      if (viewer) viewer.classList.add('is-swiper');

      /* Coalescing cross-fade — no timers, no image gate. The CSS
         `opacity` transition on `.mam-bioactives__viewer` provides
         the timing; `transitionend` drives every state change so
         we never race a hard-coded `setTimeout` against real paint.
         `pendingName` tracks the latest target the caller wants;
         if the user rapid-scrolls through several tabs while a
         fade is in flight, the loop finishes the current fade,
         then picks up the newest `pendingName` at the tail. That
         gives continuous motion (framework-style) instead of an
         interrupt-and-reset that reads as a hold. */
      var pendingName = null;
      var appliedName = null;
      var fadeState = 'idle';
      /* Match the CSS `opacity` transition on
         `.mam-bioactives__viewer` (260 ms). */
      var FADE_DURATION_MS = 260;
      /* Deliberately shorter than the fade-out duration so the
         swap interrupts the transition partway through. When the
         `.is-fading` class is removed mid-transition the browser
         starts a new transition from the current computed
         opacity (~0.4, not the full 0.15 dip) back to 1 —
         eliminates the visible hold at low opacity that a
         wait-for-`transitionend` design creates. */
      var SWAP_AT_MS = 160;

      function applyItemFilter(name) {
        for (var j = 0; j < items.length; j++) {
          var match = (items[j].getAttribute('data-mam-bio-tab') === name);
          items[j].classList.toggle('is-hidden', !match);
        }
        if (grid) grid.scrollLeft = 0;
        updateNavDisabled();
      }

      /* Fetch every bioactive image up front so a tab swap never
         waits on the network. Runs once, when the section enters
         (or approaches) the viewport — before that we leave the
         `loading="lazy"` attribute alone so we don't cost anything
         above the fold if the visitor never scrolls this far. */
      function preloadAllImages() {
        for (var j = 0; j < items.length; j++) {
          var imgs = items[j].querySelectorAll('img');
          for (var i = 0; i < imgs.length; i++) {
            var img = imgs[i];
            if (img.getAttribute('loading') === 'lazy') {
              img.setAttribute('loading', 'eager');
            }
          }
        }
      }

      function runFade() {
        if (pendingName === appliedName || pendingName == null) {
          fadeState = 'idle';
          return;
        }
        fadeState = 'out';
        viewer.classList.add('is-fading');
        setTimeout(function () {
          /* Snap to whichever tab is now pending — which may be
             newer than the one the caller originally requested
             (rapid scroll). */
          var target = pendingName;
          applyItemFilter(target);
          appliedName = target;
          /* Force layout so the DOM swap commits at the current
             (mid-fade) opacity before we start the fade-in.
             Cheap synchronous reflow. */
          /* eslint-disable-next-line no-unused-expressions */
          viewer.offsetHeight;
          fadeState = 'in';
          viewer.classList.remove('is-fading');
          setTimeout(function () {
            /* Fade-in has had time to complete. If the target
               moved again during the fade, queue the next one —
               continuous motion rather than a hold. */
            if (pendingName !== appliedName) {
              runFade();
            } else {
              fadeState = 'idle';
            }
          }, FADE_DURATION_MS);
        }, SWAP_AT_MS);
      }

      function setActive(name) {
        /* Tab pills always update immediately so the click / scroll
           feedback is instant — only the card set cross-fades. */
        for (var i = 0; i < tabs.length; i++) {
          var on = (tabs[i].getAttribute('data-mam-tab') === name);
          tabs[i].classList.toggle('is-active', on);
          tabs[i].setAttribute('aria-selected', on ? 'true' : 'false');
        }
        if (!viewer || !isDesktop || reducedMotion) {
          applyItemFilter(name);
          appliedName = name;
          pendingName = name;
          return;
        }
        /* First call — no prior state to fade from, so snap. */
        if (appliedName == null) {
          applyItemFilter(name);
          appliedName = name;
          pendingName = name;
          return;
        }
        pendingName = name;
        if (fadeState === 'idle') runFade();
      }

      function nudge(direction) {
        if (!grid) return;
        /* Pick the first visible card to measure step distance —
           card width plus the grid gap. */
        var sample = null;
        for (var i = 0; i < items.length; i++) {
          if (!items[i].classList.contains('is-hidden')) {
            sample = items[i];
            break;
          }
        }
        var step = sample ? sample.offsetWidth + 20 : 280;
        grid.scrollBy({ left: direction * step, behavior: 'smooth' });
      }

      function updateNavDisabled() {
        if (!grid || !prevBtn || !nextBtn) return;
        var max = grid.scrollWidth - grid.clientWidth;
        /* When the cards fit without overflow there's nothing to
           scroll to, so hide the nav buttons entirely. The viewer's
           `.is-no-overflow` flag is also useful for any layout
           tweaks that should only apply to non-scrolling sets. */
        if (viewer) viewer.classList.toggle('is-no-overflow', max <= 1);
        var x = grid.scrollLeft;
        prevBtn.disabled = x <= 1;
        nextBtn.disabled = x >= max - 1;
      }

      if (prevBtn) prevBtn.addEventListener('click', function () { nudge(-1); });
      if (nextBtn) nextBtn.addEventListener('click', function () { nudge(1); });
      if (grid) {
        var rafScroll = 0;
        grid.addEventListener('scroll', function () {
          if (rafScroll) return;
          rafScroll = requestAnimationFrame(function () {
            rafScroll = 0;
            updateNavDisabled();
          });
        }, { passive: true });
      }
      /* Re-evaluate overflow state on viewport changes so the nav
         buttons appear / disappear correctly when the viewport
         crosses the card-fits-or-not boundary (e.g. tablet rotation,
         desktop resize, mobile chrome show/hide). */
      var resizeRaf = 0;
      window.addEventListener('resize', function () {
        if (resizeRaf) cancelAnimationFrame(resizeRaf);
        resizeRaf = requestAnimationFrame(updateNavDisabled);
      });

      /* — Scroll-pinned tab switching (desktop only) —
         Mirrors mam-framework's scaffold-plus-pin mechanic scaled
         to three tabs. Scroll progress through `.mam-bioactives__
         scroll` drives `setActive`; once the user has scrolled
         past the scaffold once we mark the section completed and
         let the layout collapse to a single viewport so further
         scrolling reads normally. Mobile / reduced-motion users
         bypass this path entirely and get the classic click-to-
         switch behaviour. */
      var scroll = section.querySelector('[data-mam-bio-scroll]');
      var pin = section.querySelector('[data-mam-bio-pin]');
      var tabOrder = ['primary', 'secondary', 'supporting'];
      var activeIdx = 0;
      var completed = false;
      var desktopMql = window.matchMedia('(min-width: 1024px)');
      var reducedMql = window.matchMedia('(prefers-reduced-motion: reduce)');
      var isDesktop = desktopMql.matches;
      var reducedMotion = reducedMql.matches;

      function clamp(n, lo, hi) { return Math.min(hi, Math.max(lo, n)); }

      function currentTabIndex(name) {
        for (var i = 0; i < tabOrder.length; i++) {
          if (tabOrder[i] === name) return i;
        }
        return 0;
      }

      var rafId = 0;
      function scheduleTick() {
        if (rafId) return;
        rafId = requestAnimationFrame(tick);
      }
      function tick() {
        rafId = 0;
        if (!isDesktop || completed || !scroll) return;
        var rect = scroll.getBoundingClientRect();
        var scrollable = scroll.offsetHeight - window.innerHeight;
        if (scrollable <= 0) return;
        var p = clamp(-rect.top / scrollable, 0, 1);
        var idx = clamp(Math.floor(p * tabOrder.length), 0, tabOrder.length - 1);
        if (idx !== activeIdx) {
          activeIdx = idx;
          setActive(tabOrder[idx]);
        }
        if (rect.bottom <= window.innerHeight + 1 && p >= 0.999) markCompleted();
      }

      /* Mirrors mam-framework.markCompleted — collapse the scaffold
         then rewind the page scroll by the height delta so the
         section doesn't jolt downward when the height snaps. */
      function markCompleted() {
        if (completed) return;
        completed = true;
        var oldHeight = scroll.offsetHeight;
        var oldScrollY = window.scrollY;
        section.classList.add('is-completed');
        var newHeight = scroll.offsetHeight;
        var delta = oldHeight - newHeight;
        if (delta > 0) {
          var target = Math.max(0, oldScrollY - delta);
          var scrollEl = document.scrollingElement || document.documentElement;
          if (scrollEl) scrollEl.scrollTop = target;
          window.scrollTo({ top: target });
          if (window.__lenis && typeof window.__lenis.scrollTo === 'function') {
            window.__lenis.scrollTo(target, { immediate: true });
          }
        }
      }

      function jumpTo(idx) {
        idx = clamp(idx, 0, tabOrder.length - 1);
        /* Post-completion, on mobile, or reduced-motion — swap the
           active set without smooth-scrolling the page. */
        if (!isDesktop || reducedMotion || completed || !scroll) {
          activeIdx = idx;
          setActive(tabOrder[idx]);
          return;
        }
        var rect = scroll.getBoundingClientRect();
        var sectionTop = rect.top + window.scrollY;
        var scrollable = scroll.offsetHeight - window.innerHeight;
        if (scrollable <= 0) {
          activeIdx = idx;
          setActive(tabOrder[idx]);
          return;
        }
        var targetProgress = (idx + 0.5) / tabOrder.length;
        var target = sectionTop + scrollable * targetProgress;
        if (window.__lenis && typeof window.__lenis.scrollTo === 'function') {
          window.__lenis.scrollTo(target, { duration: 1.0 });
        } else {
          window.scrollTo({ top: target, behavior: 'smooth' });
        }
      }

      /* Respond to viewport changes across the 1024 px boundary —
         entering desktop re-enables the scroll driver, entering
         mobile clears completion so a rotation back to desktop
         starts fresh. */
      function handleMqlChange() {
        var next = desktopMql.matches;
        if (next === isDesktop) return;
        isDesktop = next;
        if (!isDesktop) {
          completed = false;
          section.classList.remove('is-completed');
        } else {
          scheduleTick();
        }
      }
      if (desktopMql.addEventListener) desktopMql.addEventListener('change', handleMqlChange);
      else if (desktopMql.addListener) desktopMql.addListener(handleMqlChange);

      window.addEventListener('scroll', scheduleTick, { passive: true });
      window.addEventListener('resize', scheduleTick);

      /* Listen for the in-page anchor jump signal (fired by the
         hero star-rating click, etc.). Collapsing the scaffold on
         demand lets the caller scroll past the section without
         getting trapped in the pinned scroll window. */
      document.addEventListener('mam:collapse-scroll', markCompleted);

      for (var i = 0; i < tabs.length; i++) {
        (function (btn) {
          btn.addEventListener('click', function () {
            var name = btn.getAttribute('data-mam-tab');
            jumpTo(currentTabIndex(name));
          });
        })(tabs[i]);
      }
      activeIdx = currentTabIndex(initial);
      setActive(initial);
      scheduleTick();

      /* Preload every bioactive image as soon as the section gets
         near the viewport so tab swaps never wait on the network.
         `rootMargin` gives us a comfortable head-start — by the
         time the visitor actually reaches the section the fetches
         are done. Fired once, then the observer disconnects. */
      if ('IntersectionObserver' in window) {
        var preloadObserver = new IntersectionObserver(function (entries) {
          for (var e = 0; e < entries.length; e++) {
            if (entries[e].isIntersecting) {
              preloadAllImages();
              preloadObserver.disconnect();
              break;
            }
          }
        }, { rootMargin: '400px' });
        preloadObserver.observe(section);
      } else {
        preloadAllImages();
      }

      /* — Modal open / populate / close — */
      if (modal) wireModal(modal, cards);
    }

    function wireModal(modal, cards) {
      if (modal.__mamBioModalWired) return;
      modal.__mamBioModalWired = true;

      var plateEl = modal.querySelector('[data-mam-bio-modal-plate]');
      var imgEl = null;
      function ensureImg() {
        if (imgEl || !plateEl) return imgEl;
        imgEl = document.createElement('img');
        imgEl.width = 320;
        imgEl.height = 320;
        imgEl.loading = 'lazy';
        imgEl.decoding = 'async';
        imgEl.alt = '';
        plateEl.appendChild(imgEl);
        return imgEl;
      }
      var pillEl = modal.querySelector('[data-mam-bio-modal-pill]');
      var pillDotEl = modal.querySelector('[data-mam-bio-modal-pill-dot]');
      var pillLabelEl = modal.querySelector('[data-mam-bio-modal-pill-label]');
      var latinEl = modal.querySelector('[data-mam-bio-modal-latin]');
      var commonWrap = modal.querySelector('[data-mam-bio-modal-common-wrap]');
      var commonEl = modal.querySelector('[data-mam-bio-modal-common]');
      var descEl = modal.querySelector('[data-mam-bio-modal-description]');
      var videoEl = modal.querySelector('[data-mam-bio-modal-video]');
      var glossaryEl = modal.querySelector('[data-mam-bio-modal-glossary]');
      var closers = modal.querySelectorAll('[data-mam-bio-close]');

      /* Embedded player references + helpers. The player overlay sits
         inside the modal card and is populated on-demand with either
         a `<video>` (Shopify uploads / any direct video file) or a
         YouTube `<iframe>` based on URL detection. */
      var playerEl = modal.querySelector('[data-mam-bio-modal-player]');
      var playerFrameEl = modal.querySelector('[data-mam-bio-modal-player-frame]');
      var playerCloseEl = modal.querySelector('[data-mam-bio-modal-player-close]');

      function parseYouTubeId(url) {
        if (!url) return null;
        /* Covers watch?v=, youtu.be/, embed/, shorts/, /v/ — with or
           without extra query strings. IDs are always 11 characters. */
        var m = url.match(
          /(?:youtube\.com\/(?:watch\?(?:.+&)?v=|embed\/|shorts\/|v\/)|youtu\.be\/)([\w-]{11})/
        );
        return m ? m[1] : null;
      }

      function buildEmbedNode(url) {
        var ytId = parseYouTubeId(url);
        if (ytId) {
          var iframe = document.createElement('iframe');
          iframe.src = 'https://www.youtube.com/embed/' + ytId +
            '?autoplay=1&rel=0&playsinline=1&controls=0&showinfo=0';
          iframe.setAttribute(
            'allow',
            'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share'
          );
          iframe.setAttribute('allowfullscreen', '');
          iframe.setAttribute('loading', 'lazy');
          return iframe;
        }
        /* Anything else — Shopify file URLs end in .mp4/.mov, and any
           other direct video URL — uses a native `<video>` tag with
           controls so users can pause/scrub without leaving the modal. */
        var video = document.createElement('video');
        video.src = url;
        video.controls = true;
        video.autoplay = true;
        video.playsInline = true;
        video.setAttribute('preload', 'metadata');
        return video;
      }

      function openPlayer(url) {
        if (!playerEl || !playerFrameEl || !url) return;
        /* Replace any prior child (covers the back-to-back-open case). */
        while (playerFrameEl.firstChild) {
          playerFrameEl.removeChild(playerFrameEl.firstChild);
        }
        playerFrameEl.appendChild(buildEmbedNode(url));
        playerEl.hidden = false;
      }

      function closePlayer() {
        if (!playerEl || !playerFrameEl) return;
        playerEl.hidden = true;
        /* Removing the child stops playback + frees the network
           connection (especially important for autoplaying YouTube
           iframes which keep streaming until torn down). */
        while (playerFrameEl.firstChild) {
          playerFrameEl.removeChild(playerFrameEl.firstChild);
        }
      }

      if (videoEl) {
        videoEl.addEventListener('click', function (e) {
          e.preventDefault();
          var url = videoEl.getAttribute('href') || '';
          if (url && url !== '#') openPlayer(url);
        });
      }
      if (playerCloseEl) {
        playerCloseEl.addEventListener('click', closePlayer);
      }

      function open(card) {
        var src = card.getAttribute('data-bio-image') || '';
        if (src) {
          var img = ensureImg();
          if (img) {
            img.src = src;
            img.alt = card.getAttribute('data-bio-common') || card.getAttribute('data-bio-latin') || '';
            img.style.display = '';
          }
        } else if (imgEl) {
          imgEl.style.display = 'none';
        }
        if (pillEl && pillLabelEl) {
          pillEl.style.backgroundColor = card.getAttribute('data-bio-pill-bg') || '';
          pillEl.style.color = card.getAttribute('data-bio-pill-text') || '';
          pillLabelEl.textContent = card.getAttribute('data-bio-tag') || '';
          if (pillDotEl) pillDotEl.style.backgroundColor = card.getAttribute('data-bio-pill-text') || '';
        }
        if (latinEl) latinEl.textContent = card.getAttribute('data-bio-latin') || '';
        var common = card.getAttribute('data-bio-common') || '';
        if (commonEl) commonEl.textContent = common;
        if (commonWrap) commonWrap.classList.toggle('is-empty', common === '');
        if (descEl) descEl.textContent = card.getAttribute('data-bio-description') || '';
        /* Resolve both action URLs up front so we can flip the right
           layout class on the actions container regardless of which
           button gets hidden. Four shapes:
             - both visible: 2-col grid + divider (default).
             - only one visible (.is-single-action): 1-col grid, no divider.
             - neither visible (.is-empty-actions): the row is hidden
               entirely so the bottom of the modal doesn't end with
               an orphan border. */
        var videoUrl = card.getAttribute('data-bio-video-url') || '';
        var glossaryUrl = card.getAttribute('data-bio-glossary-url') || '';

        if (videoEl) {
          if (videoUrl) {
            videoEl.href = videoUrl;
            videoEl.hidden = false;
            videoEl.removeAttribute('aria-disabled');
            videoEl.classList.remove('is-disabled');
          } else {
            videoEl.href = '#';
            videoEl.hidden = true;
          }
        }
        if (glossaryEl) {
          if (glossaryUrl) {
            glossaryEl.href = glossaryUrl;
            glossaryEl.hidden = false;
          } else {
            glossaryEl.href = '#';
            glossaryEl.hidden = true;
          }
        }
        var actionsParent = (videoEl && videoEl.parentElement)
          || (glossaryEl && glossaryEl.parentElement);
        if (actionsParent) {
          var oneVisible = (!!videoUrl) !== (!!glossaryUrl);
          var noneVisible = !videoUrl && !glossaryUrl;
          actionsParent.classList.toggle('is-single-action', oneVisible);
          actionsParent.classList.toggle('is-empty-actions', noneVisible);
        }
        modal.removeAttribute('hidden');
        void modal.offsetHeight;
        modal.classList.add('is-open');
        document.documentElement.classList.add('mam-bio-modal-open');
        var closeBtn = modal.querySelector('.mam-bio-modal__close');
        if (closeBtn && closeBtn.focus) closeBtn.focus();
      }

      function close() {
        closePlayer();
        modal.classList.remove('is-open');
        document.documentElement.classList.remove('mam-bio-modal-open');
        setTimeout(function () {
          if (!modal.classList.contains('is-open')) modal.setAttribute('hidden', '');
        }, 460);
      }

      for (var i = 0; i < cards.length; i++) {
        (function (card) {
          card.addEventListener('click', function () { open(card); });
          card.addEventListener('keydown', function (e) {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              open(card);
            }
          });
        })(cards[i]);
      }

      for (var c = 0; c < closers.length; c++) {
        closers[c].addEventListener('click', close);
      }

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && modal.classList.contains('is-open')) close();
      });
    }

    function wireAll(scope) {
      var sections = (scope || document).querySelectorAll('[data-mam-bioactives]');
      for (var i = 0; i < sections.length; i++) wire(sections[i]);
    }

    ready(function () {
      wireAll(document);
      if (window.MAM) MAM.observeWordReveals(document);
    });

    document.addEventListener('shopify:section:load', function (e) {
      if (e.target && e.target.classList && e.target.classList.contains('section-mam-bioactives')) {
        wireAll(e.target);
        if (window.MAM) MAM.observeWordReveals(e.target);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mam-product-details"] && !Shopify.designMode) return;
  try {
    
  /* Product Details — accordion. Single-open behaviour: opening a row
     closes any other open row. The panel transitions on `height` so
     toggling animates smoothly; we measure the natural height before
     each open and lock to that, then unset to `auto` once the
     transition completes so the panel reflows naturally for any
     content changes (image loads, etc.). */
  (function () {
    if (window.__mamProductDetailsInit) return;
    window.__mamProductDetailsInit = true;

    function ready(fn) {
      if (document.readyState !== 'loading') fn();
      else document.addEventListener('DOMContentLoaded', fn);
    }

    function wire(section) {
      if (section.__mamProductDetailsWired) return;
      section.__mamProductDetailsWired = true;
      var rows = section.querySelectorAll('.mam-product-details__row');

      function close(row) {
        var trigger = row.querySelector('[data-mam-row-trigger]');
        var panel = row.querySelector('[data-mam-row-panel]');
        if (!panel || !trigger) return;
        if (trigger.getAttribute('aria-expanded') !== 'true') return;
        trigger.setAttribute('aria-expanded', 'false');
        /* Lock to current height, then animate to 0. */
        panel.style.height = panel.scrollHeight + 'px';
        void panel.offsetHeight;
        panel.style.height = '0px';
        var onEnd = function (e) {
          if (e.propertyName !== 'height') return;
          panel.removeEventListener('transitionend', onEnd);
          panel.setAttribute('hidden', '');
          panel.style.height = '';
        };
        panel.addEventListener('transitionend', onEnd);
      }

      function open(row) {
        var trigger = row.querySelector('[data-mam-row-trigger]');
        var panel = row.querySelector('[data-mam-row-panel]');
        if (!panel || !trigger) return;
        /* Close any other open row first. */
        for (var i = 0; i < rows.length; i++) {
          if (rows[i] !== row) close(rows[i]);
        }
        trigger.setAttribute('aria-expanded', 'true');
        panel.removeAttribute('hidden');
        panel.style.height = '0px';
        /* Force reflow so the height transition runs from 0 → measured. */
        void panel.offsetHeight;
        var target = panel.scrollHeight;
        panel.style.height = target + 'px';
        var onEnd = function (e) {
          if (e.propertyName !== 'height') return;
          panel.removeEventListener('transitionend', onEnd);
          panel.style.height = 'auto';
        };
        panel.addEventListener('transitionend', onEnd);
      }

      for (var i = 0; i < rows.length; i++) {
        (function (row) {
          var trigger = row.querySelector('[data-mam-row-trigger]');
          if (!trigger) return;
          trigger.addEventListener('click', function () {
            if (trigger.getAttribute('aria-expanded') === 'true') {
              close(row);
            } else {
              open(row);
            }
          });
        })(rows[i]);
      }
    }

    function wireAll(scope) {
      var sections = (scope || document).querySelectorAll('[data-mam-product-details]');
      for (var i = 0; i < sections.length; i++) wire(sections[i]);
    }

    ready(function () {
      wireAll(document);
      if (window.MAM) MAM.observeWordReveals(document);
    });

    document.addEventListener('shopify:section:load', function (e) {
      if (e.target && e.target.classList && e.target.classList.contains('section-mam-product-details')) {
        wireAll(e.target);
        if (window.MAM) MAM.observeWordReveals(e.target);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mam-product-hero"] && !Shopify.designMode) return;
  try {
    
  /* Product hero — gallery thumbnail swap + quantity stepper. The
     thumbs are buttons carrying the full-size URL on a data attr;
     clicking one swaps the main <img>. The stepper drives the
     `name=quantity` input that the standard Shopify product form
     submits. Variant <select>s submit `options[Name]` so Shopify's
     storefront resolves the right variant on add. */
  (function () {
    if (window.__mamProductHeroInit) return;
    window.__mamProductHeroInit = true;

    function ready(fn) {
      if (document.readyState !== 'loading') fn();
      else document.addEventListener('DOMContentLoaded', fn);
    }

    function wire(section) {
      if (section.__mamProductHeroWired) return;
      section.__mamProductHeroWired = true;

      function normalizeBioKey(value) {
        return (value || '')
          .toString()
          .toLowerCase()
          .replace(/\s+/g, ' ')
          .trim();
      }

      function syncMiniBioactivesFromMain() {
        var miniCards = section.querySelectorAll('[data-mam-bio-mini]');
        if (!miniCards.length) return;

        var sourceCards = document.querySelectorAll('[data-mam-bio-card]');
        if (!sourceCards.length) return;

        var byCommon = {};
        var byLatin = {};

        for (var s = 0; s < sourceCards.length; s++) {
          var sourceCard = sourceCards[s];
          var common = normalizeBioKey(sourceCard.getAttribute('data-bio-common'));
          var latin = normalizeBioKey(sourceCard.getAttribute('data-bio-latin'));

          if (common && !byCommon[common]) byCommon[common] = sourceCard;
          if (latin && !byLatin[latin]) byLatin[latin] = sourceCard;
        }

        for (var i = 0; i < miniCards.length; i++) {
          var miniCard = miniCards[i];
          var miniCommon = normalizeBioKey(miniCard.getAttribute('data-mam-bio-mini-common'));
          var miniLatin = normalizeBioKey(miniCard.getAttribute('data-mam-bio-mini-latin'));
          var source = byCommon[miniCommon] || byLatin[miniLatin];

          if (!source) continue;

          var sourceImage = source.getAttribute('data-bio-image') || '';
          var sourceTag = source.getAttribute('data-bio-tag') || '';
          var sourcePillBg = source.getAttribute('data-bio-pill-bg') || '';
          var sourcePillText = source.getAttribute('data-bio-pill-text') || '';

          if (sourceImage) {
            var img = miniCard.querySelector('[data-mam-bio-mini-img]');
            var imageWrap = miniCard.querySelector('.mam-product-hero__bioactives-image');

            if (!img && imageWrap) {
              img = document.createElement('img');
              img.setAttribute('data-mam-bio-mini-img', '');
              img.alt = miniCard.getAttribute('data-mam-bio-mini-common') || '';
              img.width = 800;
              img.height = 800;
              img.loading = 'lazy';
              img.decoding = 'async';
              imageWrap.innerHTML = '';
              imageWrap.appendChild(img);
            }

            if (img) {
              img.src = sourceImage;
              img.removeAttribute('srcset');
              img.removeAttribute('sizes');
            }
          }

          if (sourceTag) {
            var pill = miniCard.querySelector('[data-mam-bio-mini-pill]');
            if (pill) {
              var dot = miniCard.querySelector('[data-mam-bio-mini-dot]');
              var labelNode = pill.lastChild;

              if (sourcePillBg) pill.style.backgroundColor = sourcePillBg;
              if (sourcePillText) {
                pill.style.color = sourcePillText;
                if (dot) dot.style.backgroundColor = sourcePillText;
              }

              if (labelNode && labelNode.nodeType === 3) {
                labelNode.nodeValue = ' ' + sourceTag;
              } else {
                pill.appendChild(document.createTextNode(' ' + sourceTag));
              }
            }
          }
        }
      }

      /* — Gallery thumbs — */
      var main = section.querySelector('[data-mam-gallery-main]');
      var activeImg = main ? main.querySelector('[data-mam-gallery-active]') : null;
      var thumbs = section.querySelectorAll('[data-mam-thumb]');
      for (var i = 0; i < thumbs.length; i++) {
        (function (btn) {
          btn.addEventListener('click', function () {
            if (!activeImg) return;
            var src = btn.getAttribute('data-mam-thumb-src');
            var alt = btn.getAttribute('data-mam-thumb-alt') || '';
            if (!src) return;
            main.classList.add('is-swapping');
            var pre = new Image();
            pre.onload = function () {
              activeImg.src = src;
              activeImg.removeAttribute('srcset');
              activeImg.alt = alt;
              /* Reflow then drop the swapping class so opacity transitions back. */
              requestAnimationFrame(function () {
                main.classList.remove('is-swapping');
              });
            };
            pre.src = src;
            for (var j = 0; j < thumbs.length; j++) {
              var on = (thumbs[j] === btn);
              thumbs[j].classList.toggle('is-active', on);
              thumbs[j].setAttribute('aria-pressed', on ? 'true' : 'false');
            }
          });
        })(thumbs[i]);
      }

      /* — Thumbnails swiper — */
      var thumbsWrap = section.querySelector('[data-mam-thumbs-wrap]');
      var thumbsTrack = section.querySelector('[data-mam-thumbs-track]');
      var thumbsPrev = section.querySelector('[data-mam-thumbs-prev]');
      var thumbsNext = section.querySelector('[data-mam-thumbs-next]');
      if (thumbsWrap && thumbsTrack) {
        function updateThumbsState() {
          var canScroll = thumbsTrack.scrollWidth > thumbsTrack.clientWidth + 1;
          thumbsWrap.setAttribute('data-can-scroll', canScroll ? 'true' : 'false');
          /* Account for sub-pixel rounding when comparing scroll
             extremes — anything within 1px is considered at the edge
             so the matching arrow dims at the natural stop. */
          var atStart = thumbsTrack.scrollLeft <= 1;
          var atEnd = (thumbsTrack.scrollLeft + thumbsTrack.clientWidth) >= (thumbsTrack.scrollWidth - 1);
          thumbsWrap.setAttribute('data-at-start', atStart ? 'true' : 'false');
          thumbsWrap.setAttribute('data-at-end', atEnd ? 'true' : 'false');
        }
        function stepThumbs(direction) {
          /* Scroll one "page" worth of thumbs at a time — roughly 4
             thumbs + gaps, which matches the initial viewport width
             when 4 are visible. */
          var step = thumbsTrack.clientWidth * 0.85;
          thumbsTrack.scrollBy({ left: direction * step, behavior: 'smooth' });
        }
        if (thumbsPrev) thumbsPrev.addEventListener('click', function () { stepThumbs(-1); });
        if (thumbsNext) thumbsNext.addEventListener('click', function () { stepThumbs(1); });
        thumbsTrack.addEventListener('scroll', updateThumbsState, { passive: true });
        window.addEventListener('resize', updateThumbsState);
        /* Re-evaluate once each thumbnail image has loaded — without
           this the very first paint can report a zero `scrollWidth`
           and the at-start state never gets set, so the prev arrow
           shows at full opacity until the user scrolls. */
        var thumbImgs = thumbsTrack.querySelectorAll('img');
        for (var ti = 0; ti < thumbImgs.length; ti++) {
          if (thumbImgs[ti].complete) continue;
          thumbImgs[ti].addEventListener('load', updateThumbsState, { once: true });
        }
        if ('ResizeObserver' in window) {
          var thumbsRO = new ResizeObserver(updateThumbsState);
          thumbsRO.observe(thumbsTrack);
        }
        updateThumbsState();
      }

      /* — Quantity stepper — */
      var qtyInput = section.querySelector('[data-mam-qty-input]');
      var dec = section.querySelector('[data-mam-qty-dec]');
      var inc = section.querySelector('[data-mam-qty-inc]');
      function clampQty(v) {
        var n = parseInt(v, 10);
        if (!isFinite(n) || n < 1) n = 1;
        return n;
      }
      if (qtyInput) {
        qtyInput.addEventListener('change', function () {
          qtyInput.value = clampQty(qtyInput.value);
        });
      }
      if (dec && qtyInput) {
        dec.addEventListener('click', function () {
          qtyInput.value = Math.max(1, clampQty(qtyInput.value) - 1);
        });
      }
      if (inc && qtyInput) {
        inc.addEventListener('click', function () {
          qtyInput.value = clampQty(qtyInput.value) + 1;
        });
      }

      /* — Trust row wrap detection —
         Measures whether the trust items would fit on a single line
         (their natural widths + a 16px minimum gap per separator).
         If they don't fit, flag the list `.is-wrapped` so CSS hides
         the separators and switches to a wrapped `space-between`
         layout. Re-evaluated on resize + after fonts load (text width
         can shift as fonts swap in). */
      var trustRow = section.querySelector('[data-mam-trust-row]');
      if (trustRow) {
        var trustItems = trustRow.querySelectorAll('.mam-product-hero__trust-item');
        var trustSepCount = trustItems.length > 0 ? trustItems.length - 1 : 0;
        var MIN_GAP = 16;
        function syncTrustWrap() {
          if (trustItems.length < 2) return;
          /* Measure natural item widths (offsetWidth reflects layout
             width, but items have flex: 0 0 auto so it equals their
             content-driven width whether wrapped or not). */
          var total = 0;
          for (var t = 0; t < trustItems.length; t++) {
            total += trustItems[t].offsetWidth;
          }
          var minNeeded = total + trustSepCount * MIN_GAP;
          if (minNeeded > trustRow.clientWidth + 1) {
            trustRow.classList.add('is-wrapped');
          } else {
            trustRow.classList.remove('is-wrapped');
          }
        }
        syncTrustWrap();
        window.addEventListener('resize', syncTrustWrap);
        if ('ResizeObserver' in window) {
          var ro = new ResizeObserver(syncTrustWrap);
          ro.observe(trustRow);
        }
        if (document.fonts && document.fonts.ready) {
          document.fonts.ready.then(syncTrustWrap).catch(function () {});
        }
      }

      syncMiniBioactivesFromMain();

      /* Jump to the Yotpo reviews section when the hero star
         rating is clicked. Prefers Lenis (the site's smooth-scroll
         driver) when present so the motion matches every other
         in-page anchor. Enter / Space activate the same handler
         so the affordance is keyboard-usable.

         Any scroll-pinned sections between here and the reviews
         target (bioactives, framework when not in flat mode) would
         otherwise trap the scroll, because their tall scaffold
         means the review section's true Y is far below where the
         scaffold ends. We fire `mam:collapse-scroll` first — each
         pinned section listens for it and calls its `markCompleted`
         path, dropping the scaffold to a single viewport so the
         reviews section's Y position resolves correctly. */
      var starsEl = section.querySelector('[data-mam-scroll-to-reviews]');
      if (starsEl) {
        function jumpToReviews() {
          var target = document.querySelector('[data-mam-yotpo-reviews]');
          if (!target) return;
          document.dispatchEvent(new CustomEvent('mam:collapse-scroll'));
          /* Wait a frame so the collapsed scaffolds' new heights
             are committed before we compute the scroll target. */
          requestAnimationFrame(function () {
            if (window.__lenis && typeof window.__lenis.scrollTo === 'function') {
              window.__lenis.scrollTo(target, { duration: 1.2 });
            } else {
              target.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
          });
        }
        starsEl.addEventListener('click', jumpToReviews);
        starsEl.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
            e.preventDefault();
            jumpToReviews();
          }
        });
      }
    }

    function wireAll(scope) {
      var sections = (scope || document).querySelectorAll('[data-mam-product-hero]');
      for (var i = 0; i < sections.length; i++) wire(sections[i]);
    }

    ready(function () {
      wireAll(document);
      if (window.MAM) {
        MAM.observeReveals(document);
        MAM.observeWordReveals(document);
      }
    });

    document.addEventListener('shopify:section:load', function (e) {
      if (e.target && e.target.classList && e.target.classList.contains('section-mam-product-hero')) {
        wireAll(e.target);
        if (window.MAM) {
          MAM.observeReveals(e.target);
          MAM.observeWordReveals(e.target);
        }
      }

      if (e.target && e.target.classList && e.target.classList.contains('section-mam-product-bioactives')) {
        wireAll(document);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mam-product-page-scrollers"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__mamProductScrollerInit) return;
  window.__mamProductScrollerInit = true;

  function wire(section) {
    if (!section || section.__mamProductScrollerWired) return;
    section.__mamProductScrollerWired = true;
  }

  function wireAll(scope) {
    var sections = (scope || document).querySelectorAll('[data-mam-product-scrollers]');
    for (var i = 0; i < sections.length; i++) wire(sections[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { wireAll(document); });
  } else {
    wireAll(document);
  }

  document.addEventListener('shopify:section:load', function (e) {
    wireAll(e.target || document);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mam-product-sticky-bar"] && !Shopify.designMode) return;
  try {
    
  /* Sticky Product Bar — visibility tied to whether the hero is past
     the viewport AND the footer is still below the fold. Mirrors the
     React StickyProductBar logic. Listens on scroll + resize via rAF
     coalescing so the check runs at most once per frame. */
  (function () {
    if (window.__mamStickyBarInit) return;
    window.__mamStickyBarInit = true;

    function ready(fn) {
      if (document.readyState !== 'loading') fn();
      else document.addEventListener('DOMContentLoaded', fn);
    }

    /* Sticky bar is now always visible on the product page — the
       hero / footer scroll-gating has been retired. `wire()` still
       runs (so future re-enables can just restore the tick logic)
       but only ensures the bar isn't hidden and no scroll / resize
       listeners are attached. */
    function wire(bar) {
      if (bar.__mamStickyBarWired) return;
      bar.__mamStickyBarWired = true;
      if (bar.hasAttribute('hidden')) bar.removeAttribute('hidden');
      bar.classList.add('is-visible');
      bar.setAttribute('aria-hidden', 'false');
    }

    function wireAll(scope) {
      var bars = (scope || document).querySelectorAll('[data-mam-sticky-bar]');
      for (var i = 0; i < bars.length; i++) wire(bars[i]);
    }

    ready(function () { wireAll(document); });

    document.addEventListener('shopify:section:load', function (e) {
      if (e.target && e.target.classList && e.target.classList.contains('section-mam-sticky-bar')) {
        wireAll(e.target);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mam-search"]) return;
  try {
    
  (function () {
    if (window.__mamSearchInit) return;
    window.__mamSearchInit = true;
    function ready(fn) {
      if (document.readyState !== 'loading') fn();
      else document.addEventListener('DOMContentLoaded', fn);
    }
    function observe(scope) {
      if (!scope || !window.MAM) return;
      MAM.observeReveals(scope);
      MAM.observeWordReveals(scope);
    }
    ready(function () { observe(document); });
    document.addEventListener('shopify:section:load', function (e) {
      if (e && e.target && e.target.classList
          && e.target.classList.contains('section-mam-search')) {
        observe(e.target);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mam-shop-archive"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__mamShopArchiveInit) return;
    window.__mamShopArchiveInit = true;
    function ready(fn) {
      if (document.readyState !== 'loading') fn();
      else document.addEventListener('DOMContentLoaded', fn);
    }
    function initAll(scope) {
      if (window.MAM) {
        MAM.observeReveals(scope || document);
        MAM.observeWordReveals(scope || document);
      }
    }
    ready(function () { initAll(document); });
    document.addEventListener('shopify:section:load', function (e) {
      if (e.target) initAll(e.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mam-social-proof"] && !Shopify.designMode) return;
  try {
    
  /* Social proof reel — auto-advancing infinite marquee using
     transform-based positioning so sub-pixel speeds render smoothly
     on the compositor (no per-frame quantization the way scrollLeft
     does). Mouse + touch drag scrubs the offset directly; releasing
     resumes auto-advance. Hover pauses on pointer devices. */
  (function () {
    if (window.__mamSocialReelInit) return;
    window.__mamSocialReelInit = true;

    /* px per frame at 60fps. Auto-advance carries the reel at
       ~150 px/s — roughly one 320px card every ~2 seconds. Tune by
       editing this constant. */
    var SPEED = 0.8;

    function ready(fn) {
      if (document.readyState !== 'loading') fn();
      else document.addEventListener('DOMContentLoaded', fn);
    }

    function init(reel) {
      if (reel.__mamReelWired) return;
      reel.__mamReelWired = true;

      var track = reel.querySelector('[data-mam-reel-track]');
      if (!track) return;

      /* Clone every original item once so the loop has identical halves. */
      var originals = Array.prototype.slice.call(track.children);
      if (!originals.length) return;
      for (var i = 0; i < originals.length; i++) {
        var clone = originals[i].cloneNode(true);
        clone.setAttribute('data-mam-reel-clone', '');
        clone.setAttribute('aria-hidden', 'true');
        track.appendChild(clone);
      }

      var hovering = false;
      var dragging = false;
      var dragPointerId = null;
      var dragStartX = 0;
      var dragStartOffset = 0;
      var offset = 0;
      var halfWidth = 0;
      var rafId = 0;

      function measureHalf() {
        /* The loop distance is the offset between the first original and
           its clone — i.e. the width of one full set including the gap
           that follows. Using `scrollWidth/2` would include the track's
           outer padding twice and produce a small visual jump on wrap. */
        var firstOriginal = originals[0];
        var firstClone = track.querySelector('[data-mam-reel-clone]');
        if (firstOriginal && firstClone) {
          halfWidth = firstClone.offsetLeft - firstOriginal.offsetLeft;
        } else {
          halfWidth = track.scrollWidth / 2;
        }
      }
      function applyTransform() {
        track.style.transform = 'translate3d(' + (-offset) + 'px, 0, 0)';
      }
      function wrap() {
        if (halfWidth <= 0) return;
        if (offset >= halfWidth) offset -= halfWidth;
        else if (offset < 0) offset += halfWidth;
      }

      /* First measurement after layout settles — images have intrinsic
         width attrs so this is usually accurate immediately, but we
         re-measure once after load just in case. */
      measureHalf();
      window.addEventListener('load', measureHalf);
      var ro = ('ResizeObserver' in window) ? new ResizeObserver(measureHalf) : null;
      if (ro) ro.observe(track);

      function tick() {
        if (!hovering && !dragging) {
          offset += SPEED;
          wrap();
          applyTransform();
        }
        rafId = requestAnimationFrame(tick);
      }
      rafId = requestAnimationFrame(tick);

      reel.addEventListener('mouseenter', function () { hovering = true; });
      reel.addEventListener('mouseleave', function () { hovering = false; });

      var dragMoved = false;
      function onPointerDown(e) {
        dragging = true;
        dragMoved = false;
        dragPointerId = e.pointerId;
        dragStartX = e.clientX;
        dragStartOffset = offset;
        reel.classList.add('is-grabbing');
        try { reel.setPointerCapture(e.pointerId); } catch (_) {}
        /* Prevent the default so text selection / image drag don't
           interfere with the scrub gesture. */
        if (e.pointerType !== 'touch') e.preventDefault();
      }
      function onPointerMove(e) {
        if (!dragging || e.pointerId !== dragPointerId) return;
        var dx = e.clientX - dragStartX;
        if (Math.abs(dx) > 4) dragMoved = true;
        offset = dragStartOffset - dx;
        wrap();
        applyTransform();
      }
      function endDrag(e) {
        if (!dragging) return;
        if (e && e.pointerId !== dragPointerId) return;
        dragging = false;
        dragPointerId = null;
        reel.classList.remove('is-grabbing');
        if (e && reel.hasPointerCapture && reel.hasPointerCapture(e.pointerId)) {
          reel.releasePointerCapture(e.pointerId);
        }
        /* If the pointer travelled past the threshold, swallow the
           subsequent click so a scrub gesture doesn't pop the video
           modal open. The capture-phase listener self-removes. */
        if (dragMoved) {
          var swallow = function (ev) {
            ev.stopPropagation();
            ev.preventDefault();
            reel.removeEventListener('click', swallow, true);
          };
          reel.addEventListener('click', swallow, true);
          /* Safety net — remove the listener on next tick if no click
             ever fires (e.g. pointercancel). */
          setTimeout(function () {
            reel.removeEventListener('click', swallow, true);
          }, 0);
        }
      }

      reel.addEventListener('pointerdown', onPointerDown);
      reel.addEventListener('pointermove', onPointerMove);
      reel.addEventListener('pointerup', endDrag);
      reel.addEventListener('pointercancel', endDrag);
      reel.addEventListener('pointerleave', endDrag);

      reel.__mamReelCleanup = function () {
        if (rafId) cancelAnimationFrame(rafId);
        if (ro) ro.disconnect();
      };
    }

    function initAll(scope) {
      var reels = (scope || document).querySelectorAll('[data-mam-reel]');
      for (var i = 0; i < reels.length; i++) init(reels[i]);
    }

    ready(function () {
      initAll(document);
      if (window.MAM) {
        MAM.observeReveals(document);
        MAM.observeWordReveals(document);
      }
    });

    document.addEventListener('shopify:section:load', function (e) {
      if (e.target && e.target.classList && e.target.classList.contains('section-mam-social')) {
        initAll(e.target);
        if (window.MAM) {
          MAM.observeReveals(e.target);
          MAM.observeWordReveals(e.target);
        }
      }
    });

    document.addEventListener('shopify:section:unload', function (e) {
      if (!e.target || !e.target.classList || !e.target.classList.contains('section-mam-social')) return;
      var reels = e.target.querySelectorAll('[data-mam-reel]');
      for (var i = 0; i < reels.length; i++) {
        if (reels[i].__mamReelCleanup) reels[i].__mamReelCleanup();
      }
    });
  })();

  /* Social proof video modal — opens an in-page lightbox when a play
     button is clicked. Builds either a native <video> or a YouTube /
     Vimeo iframe based on the data attributes set by the Liquid
     template. The stage is cleared on close so playback always stops
     and the network connection drops. */
  (function () {
    if (window.__mamSocialModalInit) return;
    window.__mamSocialModalInit = true;

    function ready(fn) {
      if (document.readyState !== 'loading') fn();
      else document.addEventListener('DOMContentLoaded', fn);
    }

    function parseEmbed(url) {
      if (!url) return null;
      var u;
      try { u = new URL(url, window.location.origin); } catch (_) { return null; }
      var host = u.hostname.replace(/^www\./, '');
      /* YouTube */
      if (host === 'youtube.com' || host === 'm.youtube.com' || host === 'music.youtube.com') {
        if (u.pathname === '/watch') {
          var id = u.searchParams.get('v');
          if (id) return { type: 'iframe', url: 'https://www.youtube.com/embed/' + id + '?autoplay=1&rel=0&modestbranding=1&playsinline=1' };
        }
        if (u.pathname.indexOf('/embed/') === 0) {
          var sep = u.search ? '&' : '?';
          return { type: 'iframe', url: url + sep + 'autoplay=1&rel=0&playsinline=1' };
        }
        if (u.pathname.indexOf('/shorts/') === 0) {
          var sid = u.pathname.split('/')[2];
          if (sid) return { type: 'iframe', url: 'https://www.youtube.com/embed/' + sid + '?autoplay=1&rel=0&playsinline=1' };
        }
      }
      if (host === 'youtu.be') {
        var ytid = u.pathname.replace(/^\//, '').split('/')[0];
        if (ytid) return { type: 'iframe', url: 'https://www.youtube.com/embed/' + ytid + '?autoplay=1&rel=0&playsinline=1' };
      }
      /* Vimeo */
      if (host === 'vimeo.com') {
        var vid = u.pathname.replace(/^\//, '').split('/')[0];
        if (vid && /^\d+$/.test(vid)) {
          return { type: 'iframe', url: 'https://player.vimeo.com/video/' + vid + '?autoplay=1&playsinline=1' };
        }
      }
      if (host === 'player.vimeo.com') {
        var sep2 = u.search ? '&' : '?';
        return { type: 'iframe', url: url + sep2 + 'autoplay=1&playsinline=1' };
      }
      /* Direct video file (mp4 / webm / ogg / mov). */
      if (/\.(mp4|webm|ogg|mov)(\?|#|$)/i.test(u.pathname)) {
        return { type: 'video', url: url };
      }
      return null;
    }

    var lastTrigger = null;
    var modal = null;
    var stage = null;
    var bodyOverflow = '';

    function ensureModal() {
      if (modal && document.body.contains(modal)) return modal;
      modal = document.querySelector('[data-mam-video-modal]');
      stage = modal ? modal.querySelector('[data-mam-video-stage]') : null;
      return modal;
    }

    function open(card, triggerEl) {
      ensureModal();
      if (!modal || !stage) return;

      var fileSrc = card.getAttribute('data-video-src') || '';
      var urlSrc = card.getAttribute('data-video-url') || '';
      var embed = null;

      if (fileSrc) {
        embed = { type: 'video', url: fileSrc };
      } else if (urlSrc) {
        embed = parseEmbed(urlSrc);
        /* Last-ditch fallback for unknown URL formats — open externally
           rather than render a broken modal. */
        if (!embed) {
          window.open(urlSrc, '_blank', 'noopener');
          return;
        }
      } else {
        return;
      }

      lastTrigger = triggerEl || null;
      stage.innerHTML = '';

      var node;
      if (embed.type === 'video') {
        node = document.createElement('video');
        node.src = embed.url;
        node.controls = true;
        node.autoplay = true;
        node.playsInline = true;
        node.setAttribute('playsinline', '');
        node.setAttribute('webkit-playsinline', '');
      } else {
        node = document.createElement('iframe');
        node.src = embed.url;
        node.setAttribute('allow', 'autoplay; fullscreen; picture-in-picture');
        node.setAttribute('allowfullscreen', '');
        node.setAttribute('title', card.getAttribute('data-video-title') || 'Video');
      }
      stage.appendChild(node);

      modal.removeAttribute('hidden');
      /* Reflow before adding the open class so the entrance transition
         runs from the hidden state. */
      void modal.offsetHeight;
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');

      bodyOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';

      var closeBtn = modal.querySelector('.mam-social__video-modal-close');
      if (closeBtn) {
        try { closeBtn.focus({ preventScroll: true }); } catch (_) { closeBtn.focus(); }
      }

      /* Try to start playback for the native <video> — some browsers
         block autoplay on the property alone but accept a play() call
         from the same user-gesture stack. */
      if (embed.type === 'video') {
        var p = node.play && node.play();
        if (p && typeof p.catch === 'function') p.catch(function () { /* user can press the controls */ });
      }
    }

    function close() {
      if (!modal) return;
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');

      /* Wait for the fade-out before tearing down the stage so the
         video doesn't visibly snap to black mid-transition. */
      var teardown = function () {
        if (stage) {
          var v = stage.querySelector('video');
          if (v) { try { v.pause(); v.removeAttribute('src'); v.load(); } catch (_) {} }
          stage.innerHTML = '';
        }
        modal.setAttribute('hidden', '');
        document.body.style.overflow = bodyOverflow || '';
        if (lastTrigger && typeof lastTrigger.focus === 'function') {
          try { lastTrigger.focus({ preventScroll: true }); } catch (_) { lastTrigger.focus(); }
        }
        lastTrigger = null;
      };
      setTimeout(teardown, 320);
    }

    ready(function () {
      ensureModal();

      /* Delegate clicks at the document level so cards cloned later by
         the marquee init still trigger the modal. The whole card is
         a click target (mirrors the React `cursor-pointer` on the
         article) — the play button is just a visual cue. */
      document.addEventListener('click', function (e) {
        var closeEl = e.target.closest && e.target.closest('[data-mam-video-close]');
        if (closeEl) {
          close();
          return;
        }
        var card = e.target.closest && e.target.closest('[data-mam-video-card]');
        if (!card || !card.classList.contains('is-playable')) return;
        var trigger = e.target.closest('[data-mam-video-play]') || card;
        e.preventDefault();
        open(card, trigger);
      });

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && modal && !modal.hasAttribute('hidden')) close();
      });
    });

    document.addEventListener('shopify:section:load', function (e) {
      if (e.target && e.target.classList && e.target.classList.contains('section-mam-social')) {
        modal = null;
        stage = null;
        ensureModal();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mam-sourcing-ingredients"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__mamSourcingIngredientsInit) return;
    window.__mamSourcingIngredientsInit = true;

    function ready(fn) {
      if (document.readyState !== 'loading') fn();
      else document.addEventListener('DOMContentLoaded', fn);
    }

    function init(section) {
      if (!section || section.__mamSiWired) return;
      section.__mamSiWired = true;
      if (window.MAM) {
        MAM.observeReveals(section);
        MAM.observeWordReveals(section);
      }
    }

    ready(function () {
      var roots = document.querySelectorAll('.mam-singredients');
      for (var i = 0; i < roots.length; i++) init(roots[i]);
    });

    document.addEventListener('shopify:section:load', function (e) {
      if (e && e.target && e.target.classList
          && e.target.classList.contains('section-mam-sourcing-ingredients')) {
        var root = e.target.querySelector('.mam-singredients');
        if (root) init(root);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mam-sourcing-pillars"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__mamSourcingPillarsInit) return;
    window.__mamSourcingPillarsInit = true;

    function ready(fn) {
      if (document.readyState !== 'loading') fn();
      else document.addEventListener('DOMContentLoaded', fn);
    }

    function init(section) {
      if (!section || section.__mamSpWired) return;
      section.__mamSpWired = true;
      if (window.MAM) {
        MAM.observeReveals(section);
        MAM.observeWordReveals(section);
      }
    }

    ready(function () {
      var roots = document.querySelectorAll('.mam-sourcing-pillars');
      for (var i = 0; i < roots.length; i++) init(roots[i]);
    });

    document.addEventListener('shopify:section:load', function (e) {
      if (e && e.target && e.target.classList
          && e.target.classList.contains('section-mam-sourcing-pillars')) {
        var root = e.target.querySelector('.mam-sourcing-pillars');
        if (root) init(root);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mam-sourcing-principles"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__mamSourcingPrinciplesInit) return;
    window.__mamSourcingPrinciplesInit = true;

    function ready(fn) {
      if (document.readyState !== 'loading') fn();
      else document.addEventListener('DOMContentLoaded', fn);
    }

    function init(section) {
      if (!section || section.__mamSpWired) return;
      section.__mamSpWired = true;
      if (window.MAM) {
        MAM.observeReveals(section);
        MAM.observeWordReveals(section);
      }
    }

    ready(function () {
      var roots = document.querySelectorAll('.mam-sourcing-principles');
      for (var i = 0; i < roots.length; i++) init(roots[i]);
    });

    document.addEventListener('shopify:section:load', function (e) {
      if (e && e.target && e.target.classList
          && e.target.classList.contains('section-mam-sourcing-principles')) {
        var root = e.target.querySelector('.mam-sourcing-principles');
        if (root) init(root);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mam-sourcing-process"] && !Shopify.designMode) return;
  try {
    
  /* Scroll-pinned arc carousel for the Sourcing Formulation Process.
     Adapts the homepage mam-process-cards arc geometry to the 18°
     spacing used by the React FormulationProcess (6 cards), and to
     text-only cards (no image vignette / card edge). */
  (function () {
    if (window.__mamSourcingProcessInit) return;
    window.__mamSourcingProcessInit = true;

    /* Arc geometry — matches the React reference exactly. */
    var ANGLE_PER_STEP_DEG = 18;
    var ANGLE_PER_STEP_RAD = (ANGLE_PER_STEP_DEG * Math.PI) / 180;
    var ARC_RADIUS = 1050;

    var prefersReducedMotion =
      window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function makeSpring(initial) {
      var value = initial;
      var velocity = 0;
      var stiffness = 140;
      var damping = 28;
      var mass = 0.35;
      return {
        step: function (target, dt) {
          var force = -stiffness * (value - target);
          var dampingForce = -damping * velocity;
          var accel = (force + dampingForce) / mass;
          velocity += accel * dt;
          value += velocity * dt;
          if (Math.abs(velocity) < 0.001 && Math.abs(value - target) < 0.001) {
            value = target;
            velocity = 0;
          }
          return value;
        },
        get: function () { return value; },
        set: function (v) { value = v; velocity = 0; }
      };
    }

    function clamp(v, lo, hi) { return v < lo ? lo : (v > hi ? hi : v); }

    function init(root) {
      if (root.__mamSprocInited) return;
      root.__mamSprocInited = true;

      var pin = root.querySelector('[data-mam-sproc-pin]');
      if (!pin) return;
      var cards = Array.prototype.slice.call(
        pin.querySelectorAll('[data-mam-sproc-card]')
      );
      var panels = Array.prototype.slice.call(
        pin.querySelectorAll('[data-mam-sproc-panel-item]')
      );
      var stepCount = parseInt(pin.getAttribute('data-step-count'), 10) || cards.length;
      if (stepCount <= 1 || cards.length === 0) return;

      var spring = makeSpring(0);
      var lastFrame = 0;
      var rafId = 0;
      var targetCenter = 0;
      var activeIdx = 0;
      var scrollDirty = true;

      function readScroll() {
        var rect = root.getBoundingClientRect();
        var scrollable = root.offsetHeight - window.innerHeight;
        if (scrollable <= 0) {
          targetCenter = 0;
          return;
        }
        var scrolled = -rect.top;
        var p = clamp(scrolled / scrollable, 0, 1);
        targetCenter = p * (stepCount - 1);
      }

      function applyArc(center) {
        for (var i = 0; i < cards.length; i++) {
          var card = cards[i];
          var theta = (i - center) * ANGLE_PER_STEP_RAD;
          var x = ARC_RADIUS * Math.sin(theta);
          var y = ARC_RADIUS * (1 - Math.cos(theta));
          var rot = (i - center) * ANGLE_PER_STEP_DEG;
          var d = Math.abs(i - center);
          /* Matches the React opacity ramp: d<=1 → 1−0.28d, else 0.72−(d−1)·0.9. */
          var opacity = d <= 1
            ? 1 - d * 0.28
            : Math.max(0, 0.72 - (d - 1) * 0.9);
          var scale = Math.max(0.82, 1 - d * 0.07);
          card.style.setProperty('--card-x', x + 'px');
          card.style.setProperty('--card-y', y + 'px');
          card.style.setProperty('--card-rot', rot + 'deg');
          card.style.setProperty('--card-scale', scale.toFixed(3));
          card.style.setProperty('--card-opacity', opacity.toFixed(3));
        }
        var idx = clamp(Math.round(center), 0, stepCount - 1);
        if (idx !== activeIdx) updateActive(idx);
      }

      function updateActive(next) {
        var prev = activeIdx;
        activeIdx = next;
        for (var i = 0; i < cards.length; i++) {
          if (i === next) cards[i].classList.add('is-active');
          else cards[i].classList.remove('is-active');
        }
        for (var j = 0; j < panels.length; j++) {
          var panel = panels[j];
          if (j === next) {
            panel.classList.remove('is-leaving');
            panel.removeAttribute('aria-hidden');
            void panel.offsetWidth;
            panel.classList.add('is-active');
          } else if (j === prev) {
            panel.classList.remove('is-active');
            panel.classList.add('is-leaving');
            panel.setAttribute('aria-hidden', 'true');
          } else {
            panel.classList.remove('is-active');
            panel.classList.remove('is-leaving');
            panel.setAttribute('aria-hidden', 'true');
          }
        }
      }

      function tick(now) {
        if (!lastFrame) lastFrame = now;
        var dt = Math.min((now - lastFrame) / 1000, 0.05);
        lastFrame = now;
        if (scrollDirty) { readScroll(); scrollDirty = false; }
        var current = spring.step(targetCenter, dt);
        applyArc(current);
        var settled =
          Math.abs(current - targetCenter) < 0.0008 &&
          Math.abs(spring.get() - targetCenter) < 0.0008;
        if (!settled) rafId = requestAnimationFrame(tick);
        else { rafId = 0; lastFrame = 0; }
      }

      function schedule() {
        scrollDirty = true;
        if (!rafId) {
          lastFrame = 0;
          rafId = requestAnimationFrame(tick);
        }
      }

      if (prefersReducedMotion) {
        for (var k = 0; k < panels.length; k++) {
          panels[k].classList.add('is-active');
          panels[k].removeAttribute('aria-hidden');
        }
        return;
      }

      readScroll();
      spring.set(targetCenter);
      applyArc(targetCenter);

      window.addEventListener('scroll', schedule, { passive: true });
      window.addEventListener('resize', schedule);
    }

    function initAll(scope) {
      var roots = (scope || document).querySelectorAll('[data-mam-sourcing-process]');
      for (var i = 0; i < roots.length; i++) init(roots[i]);
    }

    if (document.readyState !== 'loading') initAll(document);
    else document.addEventListener('DOMContentLoaded', function () { initAll(document); });

    document.addEventListener('shopify:section:load', function (e) {
      if (e && e.target && e.target.classList
          && e.target.classList.contains('section-mam-sourcing-process')) {
        initAll(e.target);
      }
    });

    document.addEventListener('DOMContentLoaded', function () {
      if (window.MAM) {
        var roots = document.querySelectorAll('[data-mam-sourcing-process]');
        for (var i = 0; i < roots.length; i++) {
          MAM.observeReveals(roots[i]);
          MAM.observeWordReveals(roots[i]);
        }
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mam-sourcing-suppliers"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__mamSourcingSuppliersInit) return;
    window.__mamSourcingSuppliersInit = true;

    function ready(fn) {
      if (document.readyState !== 'loading') fn();
      else document.addEventListener('DOMContentLoaded', fn);
    }

    function init(section) {
      if (!section || section.__mamSsWired) return;
      section.__mamSsWired = true;
      if (window.MAM) {
        MAM.observeReveals(section);
        MAM.observeWordReveals(section);
      }
    }

    ready(function () {
      var roots = document.querySelectorAll('.mam-ssuppliers');
      for (var i = 0; i < roots.length; i++) init(roots[i]);
    });

    document.addEventListener('shopify:section:load', function (e) {
      if (e && e.target && e.target.classList
          && e.target.classList.contains('section-mam-sourcing-suppliers')) {
        var root = e.target.querySelector('.mam-ssuppliers');
        if (root) init(root);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mam-statement"] && !Shopify.designMode) return;
  try {
    
  if (window.MAM) {
    MAM.observeWordReveals(document.currentScript ? document.currentScript.parentElement : document);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mam-system-builds"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__mamSysSysInit) return;
    window.__mamSysSysInit = true;
    function ready(fn) {
      if (document.readyState !== 'loading') fn();
      else document.addEventListener('DOMContentLoaded', fn);
    }
    ready(function () {
      if (!window.MAM) return;
      var roots = document.querySelectorAll('.mam-syssys');
      for (var i = 0; i < roots.length; i++) {
        MAM.observeReveals(roots[i]);
        MAM.observeWordReveals(roots[i]);
      }
    });
    document.addEventListener('shopify:section:load', function (e) {
      if (e && e.target && window.MAM) {
        MAM.observeReveals(e.target);
        MAM.observeWordReveals(e.target);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mam-why-cornwall"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__mamWhyCornwallInit) return;
    window.__mamWhyCornwallInit = true;
    function ready(fn) {
      if (document.readyState !== 'loading') fn();
      else document.addEventListener('DOMContentLoaded', fn);
    }

    var revealObserver = null;
    function getRevealObserver() {
      if (revealObserver) return revealObserver;
      if (!('IntersectionObserver' in window)) return null;
      revealObserver = new IntersectionObserver(function (entries) {
        for (var i = 0; i < entries.length; i++) {
          if (entries[i].isIntersecting) {
            var el = entries[i].target;
            var delay = parseInt(el.getAttribute('data-mam-reveal-delay') || '0', 10);
            if (delay > 0) {
              setTimeout(function () { el.classList.add('is-shown'); }, delay);
            } else {
              el.classList.add('is-shown');
            }
            revealObserver.unobserve(el);
          }
        }
      }, { rootMargin: '0px 0px -10% 0px', threshold: 0.05 });
      return revealObserver;
    }
    function observeReveals(scope) {
      var els = (scope || document).querySelectorAll('[data-mam-reveal]:not(.is-shown)');
      var obs = getRevealObserver();
      if (!obs) {
        for (var i = 0; i < els.length; i++) els[i].classList.add('is-shown');
        return;
      }
      for (var j = 0; j < els.length; j++) obs.observe(els[j]);
    }

    function wire(section) {
      if (section.__mamWhyCornwallWired) return;
      section.__mamWhyCornwallWired = true;
      var btn = section.querySelector('[data-mam-wc-play]');
      var video = section.querySelector('[data-mam-wc-video]');
      if (btn && video) {
        btn.addEventListener('click', function () {
          section.classList.add('is-playing');
          var p = video.play();
          if (p && typeof p.catch === 'function') p.catch(function () {});
        });
        video.addEventListener('pause', function () {
          if (video.ended) section.classList.remove('is-playing');
        });
        video.addEventListener('ended', function () {
          section.classList.remove('is-playing');
        });
      }
      observeReveals(section);
    }
    function wireAll(scope) {
      var roots = (scope || document).querySelectorAll('[data-mam-why-cornwall]');
      for (var i = 0; i < roots.length; i++) wire(roots[i]);
    }
    ready(function () { wireAll(document); });
    document.addEventListener('shopify:section:load', function (e) {
      if (e.target && e.target.classList && e.target.classList.contains('section-mam-why-cornwall')) {
        wireAll(e.target);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
